var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 252,
    viewBox: "0 0 1920 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 1.30078H0V251.301H1920V1.30078Z",
    fill: "#FF8B66"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2519_11339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 250
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V250H1920V0Z",
    fill: "#FF8B66"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2519_11339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1851 27.6703V-16.4309H1866L1871.7 -6.36213L1878.8 -16.4309H1900.4L1909.6 -27.8086L1925.9 27.6703H1851Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851 27.6703V-16.4309H1866L1871.7 -6.36213L1878.8 -16.4309H1900.4L1909.6 -27.8086L1925.9 27.6703H1851Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.8 15.0843C1909.06 15.0843 1911.7 12.4246 1911.7 9.14369C1911.7 5.86281 1909.06 3.20312 1905.8 3.20312C1902.54 3.20312 1899.9 5.86281 1899.9 9.14369C1899.9 12.4246 1902.54 15.0843 1905.8 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.7 14.5822C1892.1 14.5822 1892.1 10.5547 1888.4 10.5547C1884.8 10.5547 1884.8 14.5822 1881.1 14.5822C1877.5 14.5822 1877.5 10.5547 1873.8 10.5547C1870.2 10.5547 1870.2 14.5822 1866.5 14.5822C1862.8 14.5822 1862.9 10.5547 1859.2 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.7 7.63688C1892.1 7.63688 1892.1 3.60938 1888.4 3.60938C1884.8 3.60938 1884.8 7.63688 1881.1 7.63688C1877.5 7.63688 1877.5 3.60938 1873.8 3.60938C1870.2 3.60938 1870.2 7.63688 1866.5 7.63688C1862.8 7.63688 1862.9 3.60938 1859.2 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.9 39.0508V83.1519H1910.9L1905.1 73.0832L1898.1 83.1519H1876.4L1867.3 94.5296L1851 39.0508H1925.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.9 39.0508V83.1519H1910.9L1905.1 73.0832L1898.1 83.1519H1876.4L1867.3 94.5296L1851 39.0508H1925.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871 63.5178C1874.26 63.5178 1876.9 60.8582 1876.9 57.5773C1876.9 54.2964 1874.26 51.6367 1871 51.6367C1867.74 51.6367 1865.1 54.2964 1865.1 57.5773C1865.1 60.8582 1867.74 63.5178 1871 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.2 52.1406C1884.8 52.1406 1884.8 56.1681 1888.5 56.1681C1892.1 56.1681 1892.1 52.1406 1895.8 52.1406C1899.4 52.1406 1899.4 56.1681 1903.1 56.1681C1906.7 56.1681 1906.7 52.1406 1910.4 52.1406C1914.1 52.1406 1914 56.1681 1917.7 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.2 59.0859C1884.8 59.0859 1884.8 63.1134 1888.5 63.1134C1892.1 63.1134 1892.1 59.0859 1895.8 59.0859C1899.4 59.0859 1899.4 63.1134 1903.1 63.1134C1906.7 63.1134 1906.7 59.0859 1910.4 59.0859C1914.1 59.0859 1914 63.1134 1917.7 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851 155.647V111.546H1866L1871.7 121.614L1878.8 111.546H1900.4L1909.6 100.168L1925.9 155.647H1851Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851 155.647V111.546H1866L1871.7 121.614L1878.8 111.546H1900.4L1909.6 100.168L1925.9 155.647H1851Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.8 143.061C1909.06 143.061 1911.7 140.401 1911.7 137.12C1911.7 133.839 1909.06 131.18 1905.8 131.18C1902.54 131.18 1899.9 133.839 1899.9 137.12C1899.9 140.401 1902.54 143.061 1905.8 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.7 142.555C1892.1 142.555 1892.1 138.527 1888.4 138.527C1884.8 138.527 1884.8 142.555 1881.1 142.555C1877.5 142.555 1877.5 138.527 1873.8 138.527C1870.2 138.527 1870.2 142.555 1866.5 142.555C1862.8 142.555 1862.9 138.527 1859.2 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.7 135.61C1892.1 135.61 1892.1 131.582 1888.4 131.582C1884.8 131.582 1884.8 135.61 1881.1 135.61C1877.5 135.61 1877.5 131.582 1873.8 131.582C1870.2 131.582 1870.2 135.61 1866.5 135.61C1862.8 135.61 1862.9 131.582 1859.2 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.9 167.023V211.125H1910.9L1905.1 201.056L1898.1 211.125H1876.4L1867.3 222.502L1851 167.023H1925.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.9 167.023V211.125H1910.9L1905.1 201.056L1898.1 211.125H1876.4L1867.3 222.502L1851 167.023H1925.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871 191.49C1874.26 191.49 1876.9 188.831 1876.9 185.55C1876.9 182.269 1874.26 179.609 1871 179.609C1867.74 179.609 1865.1 182.269 1865.1 185.55C1865.1 188.831 1867.74 191.49 1871 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.2 180.113C1884.8 180.113 1884.8 184.141 1888.5 184.141C1892.1 184.141 1892.1 180.113 1895.8 180.113C1899.4 180.113 1899.4 184.141 1903.1 184.141C1906.7 184.141 1906.7 180.113 1910.4 180.113C1914.1 180.113 1914 184.141 1917.7 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.2 187.059C1884.8 187.059 1884.8 191.086 1888.5 191.086C1892.1 191.086 1892.1 187.059 1895.8 187.059C1899.4 187.059 1899.4 191.086 1903.1 191.086C1906.7 191.086 1906.7 187.059 1910.4 187.059C1914.1 187.059 1914 191.086 1917.7 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851 283.619V239.518H1866L1871.7 249.587L1878.8 239.518H1900.4L1909.6 228.141L1925.9 283.619H1851Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851 283.619V239.518H1866L1871.7 249.587L1878.8 239.518H1900.4L1909.6 228.141L1925.9 283.619H1851Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 83.3508V39.2497H1785.2L1790.9 49.4191L1797.9 39.2497H1819.6L1828.7 27.9727L1845 83.3508H1770.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 83.3508V39.2497H1785.2L1790.9 49.4191L1797.9 39.2497H1819.6L1828.7 27.9727L1845 83.3508H1770.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.9 -27.8086V16.2926H1815.9L1810.2 6.22382L1803.1 16.2926H1781.5L1772.3 27.6703L1756.1 -27.8086H1830.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.9 -27.8086V16.2926H1815.9L1810.2 6.22382L1803.1 16.2926H1781.5L1772.3 27.6703L1756.1 -27.8086H1830.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.7 27.6703V-16.4309H1692.7L1698.4 -6.36213L1705.5 -16.4309H1727.1L1736.3 -27.8086L1752.6 27.6703H1677.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.7 27.6703V-16.4309H1692.7L1698.4 -6.36213L1705.5 -16.4309H1727.1L1736.3 -27.8086L1752.6 27.6703H1677.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.6 15.0843C1735.86 15.0843 1738.5 12.4246 1738.5 9.14369C1738.5 5.86281 1735.86 3.20312 1732.6 3.20312C1729.34 3.20312 1726.7 5.86281 1726.7 9.14369C1726.7 12.4246 1729.34 15.0843 1732.6 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.4 14.5822C1718.8 14.5822 1718.8 10.5547 1715.1 10.5547C1711.5 10.5547 1711.5 14.5822 1707.8 14.5822C1704.2 14.5822 1704.2 10.5547 1700.5 10.5547C1696.9 10.5547 1696.9 14.5822 1693.2 14.5822C1689.6 14.5822 1689.6 10.5547 1685.9 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.4 7.63688C1718.8 7.63688 1718.8 3.60938 1715.1 3.60938C1711.5 3.60938 1711.5 7.63688 1707.8 7.63688C1704.2 7.63688 1704.2 3.60938 1700.5 3.60938C1696.9 3.60938 1696.9 7.63688 1693.2 7.63688C1689.6 7.63688 1689.6 3.60938 1685.9 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 211.327V167.226H1785.2L1790.9 177.396L1797.9 167.226H1819.6L1828.7 155.949L1845 211.327H1770.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 211.327V167.226H1785.2L1790.9 177.396L1797.9 167.226H1819.6L1828.7 155.949L1845 211.327H1770.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.6 39.0508V83.1519H1737.6L1731.9 73.0832L1724.8 83.1519H1703.2L1694 94.5296L1677.7 39.0508H1752.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.6 39.0508V83.1519H1737.6L1731.9 73.0832L1724.8 83.1519H1703.2L1694 94.5296L1677.7 39.0508H1752.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.7 63.5178C1700.96 63.5178 1703.6 60.8582 1703.6 57.5773C1703.6 54.2964 1700.96 51.6367 1697.7 51.6367C1694.44 51.6367 1691.8 54.2964 1691.8 57.5773C1691.8 60.8582 1694.44 63.5178 1697.7 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.9 52.1406C1711.5 52.1406 1711.5 56.1681 1715.2 56.1681C1718.8 56.1681 1718.8 52.1406 1722.5 52.1406C1726.1 52.1406 1726.1 56.1681 1729.8 56.1681C1733.4 56.1681 1733.4 52.1406 1737.1 52.1406C1740.7 52.1406 1740.7 56.1681 1744.4 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.9 59.0859C1711.5 59.0859 1711.5 63.1134 1715.2 63.1134C1718.8 63.1134 1718.8 59.0859 1722.5 59.0859C1726.1 59.0859 1726.1 63.1134 1729.8 63.1134C1733.4 63.1134 1733.4 59.0859 1737.1 59.0859C1740.7 59.0859 1740.7 63.1134 1744.4 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.9 100.168V144.269H1815.9L1810.2 134.2L1803.1 144.269H1781.5L1772.3 155.647L1756.1 100.168H1830.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.9 100.168V144.269H1815.9L1810.2 134.2L1803.1 144.269H1781.5L1772.3 155.647L1756.1 100.168H1830.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.1 124.635C1779.36 124.635 1782 121.975 1782 118.694C1782 115.414 1779.36 112.754 1776.1 112.754C1772.84 112.754 1770.2 115.414 1770.2 118.694C1770.2 121.975 1772.84 124.635 1776.1 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.3 113.258C1789.9 113.258 1789.9 117.285 1793.6 117.285C1797.2 117.285 1797.2 113.258 1800.9 113.258C1804.5 113.258 1804.5 117.285 1808.2 117.285C1811.8 117.285 1811.8 113.258 1815.5 113.258C1819.1 113.258 1819.1 117.285 1822.8 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.3 120.203C1789.9 120.203 1789.9 124.231 1793.6 124.231C1797.2 124.231 1797.2 120.203 1800.9 120.203C1804.5 120.203 1804.5 124.231 1808.2 124.231C1811.8 124.231 1811.8 120.203 1815.5 120.203C1819.1 120.203 1819.1 124.231 1822.8 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.7 155.647V111.546H1692.7L1698.4 121.614L1705.5 111.546H1727.1L1736.3 100.168L1752.6 155.647H1677.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.7 155.647V111.546H1692.7L1698.4 121.614L1705.5 111.546H1727.1L1736.3 100.168L1752.6 155.647H1677.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.6 143.061C1735.86 143.061 1738.5 140.401 1738.5 137.12C1738.5 133.839 1735.86 131.18 1732.6 131.18C1729.34 131.18 1726.7 133.839 1726.7 137.12C1726.7 140.401 1729.34 143.061 1732.6 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.4 142.555C1718.8 142.555 1718.8 138.527 1715.1 138.527C1711.5 138.527 1711.5 142.555 1707.8 142.555C1704.2 142.555 1704.2 138.527 1700.5 138.527C1696.9 138.527 1696.9 142.555 1693.2 142.555C1689.6 142.555 1689.6 138.527 1685.9 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.4 135.61C1718.8 135.61 1718.8 131.582 1715.1 131.582C1711.5 131.582 1711.5 135.61 1707.8 135.61C1704.2 135.61 1704.2 131.582 1700.5 131.582C1696.9 131.582 1696.9 135.61 1693.2 135.61C1689.6 135.61 1689.6 131.582 1685.9 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 83.3508V39.2497H1785.2L1790.9 49.4191L1797.9 39.2497H1819.6L1828.7 27.9727L1845 83.3508H1770.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 83.3508V39.2497H1785.2L1790.9 49.4191L1797.9 39.2497H1819.6L1828.7 27.9727L1845 83.3508H1770.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 70.8655C1828.26 70.8655 1830.9 68.2058 1830.9 64.925C1830.9 61.6441 1828.26 58.9844 1825 58.9844C1821.74 58.9844 1819.1 61.6441 1819.1 64.925C1819.1 68.2058 1821.74 70.8655 1825 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.8 70.3634C1811.2 70.3634 1811.2 66.3359 1807.5 66.3359C1803.9 66.3359 1803.9 70.3634 1800.2 70.3634C1796.6 70.3634 1796.6 66.3359 1792.9 66.3359C1789.3 66.3359 1789.3 70.3634 1785.6 70.3634C1782 70.3634 1782 66.3359 1778.3 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.8 63.4142C1811.2 63.4142 1811.2 59.3867 1807.5 59.3867C1803.9 59.3867 1803.9 63.4142 1800.2 63.4142C1796.6 63.4142 1796.6 59.3867 1792.9 59.3867C1789.3 59.3867 1789.3 63.4142 1785.6 63.4142C1782 63.4142 1782 59.3867 1778.3 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.6 167.023V211.125H1737.6L1731.9 201.056L1724.8 211.125H1703.2L1694 222.502L1677.7 167.023H1752.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.6 167.023V211.125H1737.6L1731.9 201.056L1724.8 211.125H1703.2L1694 222.502L1677.7 167.023H1752.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.7 191.49C1700.96 191.49 1703.6 188.831 1703.6 185.55C1703.6 182.269 1700.96 179.609 1697.7 179.609C1694.44 179.609 1691.8 182.269 1691.8 185.55C1691.8 188.831 1694.44 191.49 1697.7 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.9 180.113C1711.5 180.113 1711.5 184.141 1715.2 184.141C1718.8 184.141 1718.8 180.113 1722.5 180.113C1726.1 180.113 1726.1 184.141 1729.8 184.141C1733.4 184.141 1733.4 180.113 1737.1 180.113C1740.7 180.113 1740.7 184.141 1744.4 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.9 187.059C1711.5 187.059 1711.5 191.086 1715.2 191.086C1718.8 191.086 1718.8 187.059 1722.5 187.059C1726.1 187.059 1726.1 191.086 1729.8 191.086C1733.4 191.086 1733.4 187.059 1737.1 187.059C1740.7 187.059 1740.7 191.086 1744.4 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.9 228.141V272.242H1815.9L1810.2 262.173L1803.1 272.242H1781.5L1772.3 283.619L1756.1 228.141H1830.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.9 228.141V272.242H1815.9L1810.2 262.173L1803.1 272.242H1781.5L1772.3 283.619L1756.1 228.141H1830.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.1 252.608C1779.36 252.608 1782 249.948 1782 246.667C1782 243.386 1779.36 240.727 1776.1 240.727C1772.84 240.727 1770.2 243.386 1770.2 246.667C1770.2 249.948 1772.84 252.608 1776.1 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.3 241.23C1789.9 241.23 1789.9 245.258 1793.6 245.258C1797.2 245.258 1797.2 241.23 1800.9 241.23C1804.5 241.23 1804.5 245.258 1808.2 245.258C1811.8 245.258 1811.8 241.23 1815.5 241.23C1819.1 241.23 1819.1 245.258 1822.8 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.3 248.176C1789.9 248.176 1789.9 252.203 1793.6 252.203C1797.2 252.203 1797.2 248.176 1800.9 248.176C1804.5 248.176 1804.5 252.203 1808.2 252.203C1811.8 252.203 1811.8 248.176 1815.5 248.176C1819.1 248.176 1819.1 252.203 1822.8 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.7 283.619V239.518H1692.7L1698.4 249.587L1705.5 239.518H1727.1L1736.3 228.141L1752.6 283.619H1677.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.7 283.619V239.518H1692.7L1698.4 249.587L1705.5 239.518H1727.1L1736.3 228.141L1752.6 283.619H1677.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 211.327V167.226H1785.2L1790.9 177.396L1797.9 167.226H1819.6L1828.7 155.949L1845 211.327H1770.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 211.327V167.226H1785.2L1790.9 177.396L1797.9 167.226H1819.6L1828.7 155.949L1845 211.327H1770.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 198.842C1828.26 198.842 1830.9 196.182 1830.9 192.901C1830.9 189.621 1828.26 186.961 1825 186.961C1821.74 186.961 1819.1 189.621 1819.1 192.901C1819.1 196.182 1821.74 198.842 1825 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.8 198.336C1811.2 198.336 1811.2 194.309 1807.5 194.309C1803.9 194.309 1803.9 198.336 1800.2 198.336C1796.6 198.336 1796.6 194.309 1792.9 194.309C1789.3 194.309 1789.3 198.336 1785.6 198.336C1782 198.336 1782 194.309 1778.3 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.8 191.391C1811.2 191.391 1811.2 187.363 1807.5 187.363C1803.9 187.363 1803.9 191.391 1800.2 191.391C1796.6 191.391 1796.6 187.363 1792.9 187.363C1789.3 187.363 1789.3 191.391 1785.6 191.391C1782 191.391 1782 187.363 1778.3 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 83.3508V39.2497H1611.9L1617.6 49.4191L1624.7 39.2497H1646.3L1655.5 27.9727L1671.7 83.3508H1596.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 83.3508V39.2497H1611.9L1617.6 49.4191L1624.7 39.2497H1646.3L1655.5 27.9727L1671.7 83.3508H1596.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 -27.8086V16.2926H1642.7L1636.9 6.22382L1629.9 16.2926H1608.2L1599.1 27.6703L1582.8 -27.8086H1657.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 -27.8086V16.2926H1642.7L1636.9 6.22382L1629.9 16.2926H1608.2L1599.1 27.6703L1582.8 -27.8086H1657.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 27.6703V-16.4309H1519.5L1525.2 -6.36213L1532.2 -16.4309H1553.9L1563 -27.8086L1579.3 27.6703H1504.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 27.6703V-16.4309H1519.5L1525.2 -6.36213L1532.2 -16.4309H1553.9L1563 -27.8086L1579.3 27.6703H1504.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.3 15.0843C1562.56 15.0843 1565.2 12.4246 1565.2 9.14369C1565.2 5.86281 1562.56 3.20312 1559.3 3.20312C1556.04 3.20312 1553.4 5.86281 1553.4 9.14369C1553.4 12.4246 1556.04 15.0843 1559.3 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.1 14.5822C1545.5 14.5822 1545.5 10.5547 1541.8 10.5547C1538.2 10.5547 1538.2 14.5822 1534.5 14.5822C1530.9 14.5822 1530.9 10.5547 1527.2 10.5547C1523.6 10.5547 1523.6 14.5822 1519.9 14.5822C1516.3 14.5822 1516.3 10.5547 1512.6 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.1 7.63688C1545.5 7.63688 1545.5 3.60938 1541.8 3.60938C1538.2 3.60938 1538.2 7.63688 1534.5 7.63688C1530.9 7.63688 1530.9 3.60938 1527.2 3.60938C1523.6 3.60938 1523.6 7.63688 1519.9 7.63688C1516.3 7.63688 1516.3 3.60938 1512.6 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 211.327V167.226H1611.9L1617.6 177.396L1624.7 167.226H1646.3L1655.5 155.949L1671.7 211.327H1596.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 211.327V167.226H1611.9L1617.6 177.396L1624.7 167.226H1646.3L1655.5 155.949L1671.7 211.327H1596.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.3 39.0508V83.1519H1564.3L1558.6 73.0832L1551.5 83.1519H1529.9L1520.7 94.5296L1504.5 39.0508H1579.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.3 39.0508V83.1519H1564.3L1558.6 73.0832L1551.5 83.1519H1529.9L1520.7 94.5296L1504.5 39.0508H1579.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.5 63.5178C1527.76 63.5178 1530.4 60.8582 1530.4 57.5773C1530.4 54.2964 1527.76 51.6367 1524.5 51.6367C1521.24 51.6367 1518.6 54.2964 1518.6 57.5773C1518.6 60.8582 1521.24 63.5178 1524.5 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.6 52.1406C1538.2 52.1406 1538.2 56.1681 1541.9 56.1681C1545.5 56.1681 1545.5 52.1406 1549.2 52.1406C1552.8 52.1406 1552.8 56.1681 1556.5 56.1681C1560.1 56.1681 1560.1 52.1406 1563.8 52.1406C1567.4 52.1406 1567.4 56.1681 1571.1 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.6 59.0859C1538.2 59.0859 1538.2 63.1134 1541.9 63.1134C1545.5 63.1134 1545.5 59.0859 1549.2 59.0859C1552.8 59.0859 1552.8 63.1134 1556.5 63.1134C1560.1 63.1134 1560.1 59.0859 1563.8 59.0859C1567.4 59.0859 1567.4 63.1134 1571.1 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 100.168V144.269H1642.7L1636.9 134.2L1629.9 144.269H1608.2L1599.1 155.647L1582.8 100.168H1657.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 100.168V144.269H1642.7L1636.9 134.2L1629.9 144.269H1608.2L1599.1 155.647L1582.8 100.168H1657.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.8 124.635C1606.06 124.635 1608.7 121.975 1608.7 118.694C1608.7 115.414 1606.06 112.754 1602.8 112.754C1599.54 112.754 1596.9 115.414 1596.9 118.694C1596.9 121.975 1599.54 124.635 1602.8 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 113.258C1616.6 113.258 1616.6 117.285 1620.3 117.285C1623.9 117.285 1623.9 113.258 1627.6 113.258C1631.2 113.258 1631.2 117.285 1634.9 117.285C1638.5 117.285 1638.5 113.258 1642.2 113.258C1645.8 113.258 1645.8 117.285 1649.5 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 120.203C1616.6 120.203 1616.6 124.231 1620.3 124.231C1623.9 124.231 1623.9 120.203 1627.6 120.203C1631.2 120.203 1631.2 124.231 1634.9 124.231C1638.5 124.231 1638.5 120.203 1642.2 120.203C1645.8 120.203 1645.8 124.231 1649.5 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 155.647V111.546H1519.5L1525.2 121.614L1532.2 111.546H1553.9L1563 100.168L1579.3 155.647H1504.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 155.647V111.546H1519.5L1525.2 121.614L1532.2 111.546H1553.9L1563 100.168L1579.3 155.647H1504.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.3 143.061C1562.56 143.061 1565.2 140.401 1565.2 137.12C1565.2 133.839 1562.56 131.18 1559.3 131.18C1556.04 131.18 1553.4 133.839 1553.4 137.12C1553.4 140.401 1556.04 143.061 1559.3 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.1 142.555C1545.5 142.555 1545.5 138.527 1541.8 138.527C1538.2 138.527 1538.2 142.555 1534.5 142.555C1530.9 142.555 1530.9 138.527 1527.2 138.527C1523.6 138.527 1523.6 142.555 1519.9 142.555C1516.3 142.555 1516.3 138.527 1512.6 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.1 135.61C1545.5 135.61 1545.5 131.582 1541.8 131.582C1538.2 131.582 1538.2 135.61 1534.5 135.61C1530.9 135.61 1530.9 131.582 1527.2 131.582C1523.6 131.582 1523.6 135.61 1519.9 135.61C1516.3 135.61 1516.3 131.582 1512.6 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 83.3508V39.2497H1611.9L1617.6 49.4191L1624.7 39.2497H1646.3L1655.5 27.9727L1671.7 83.3508H1596.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 83.3508V39.2497H1611.9L1617.6 49.4191L1624.7 39.2497H1646.3L1655.5 27.9727L1671.7 83.3508H1596.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.7 70.8655C1654.96 70.8655 1657.6 68.2058 1657.6 64.925C1657.6 61.6441 1654.96 58.9844 1651.7 58.9844C1648.44 58.9844 1645.8 61.6441 1645.8 64.925C1645.8 68.2058 1648.44 70.8655 1651.7 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.5 70.3634C1637.9 70.3634 1637.9 66.3359 1634.2 66.3359C1630.6 66.3359 1630.6 70.3634 1626.9 70.3634C1623.3 70.3634 1623.3 66.3359 1619.6 66.3359C1616 66.3359 1616 70.3634 1612.3 70.3634C1608.7 70.3634 1608.7 66.3359 1605 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.5 63.4142C1637.9 63.4142 1637.9 59.3867 1634.2 59.3867C1630.6 59.3867 1630.6 63.4142 1626.9 63.4142C1623.3 63.4142 1623.3 59.3867 1619.6 59.3867C1616 59.3867 1616 63.4142 1612.3 63.4142C1608.7 63.4142 1608.7 59.3867 1605 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.3 167.023V211.125H1564.3L1558.6 201.056L1551.5 211.125H1529.9L1520.7 222.502L1504.5 167.023H1579.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.3 167.023V211.125H1564.3L1558.6 201.056L1551.5 211.125H1529.9L1520.7 222.502L1504.5 167.023H1579.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.5 191.49C1527.76 191.49 1530.4 188.831 1530.4 185.55C1530.4 182.269 1527.76 179.609 1524.5 179.609C1521.24 179.609 1518.6 182.269 1518.6 185.55C1518.6 188.831 1521.24 191.49 1524.5 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.6 180.113C1538.2 180.113 1538.2 184.141 1541.9 184.141C1545.5 184.141 1545.5 180.113 1549.2 180.113C1552.8 180.113 1552.8 184.141 1556.5 184.141C1560.1 184.141 1560.1 180.113 1563.8 180.113C1567.4 180.113 1567.4 184.141 1571.1 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.6 187.059C1538.2 187.059 1538.2 191.086 1541.9 191.086C1545.5 191.086 1545.5 187.059 1549.2 187.059C1552.8 187.059 1552.8 191.086 1556.5 191.086C1560.1 191.086 1560.1 187.059 1563.8 187.059C1567.4 187.059 1567.4 191.086 1571.1 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 228.141V272.242H1642.7L1636.9 262.173L1629.9 272.242H1608.2L1599.1 283.619L1582.8 228.141H1657.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 228.141V272.242H1642.7L1636.9 262.173L1629.9 272.242H1608.2L1599.1 283.619L1582.8 228.141H1657.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.8 252.608C1606.06 252.608 1608.7 249.948 1608.7 246.667C1608.7 243.386 1606.06 240.727 1602.8 240.727C1599.54 240.727 1596.9 243.386 1596.9 246.667C1596.9 249.948 1599.54 252.608 1602.8 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 241.23C1616.6 241.23 1616.6 245.258 1620.3 245.258C1623.9 245.258 1623.9 241.23 1627.6 241.23C1631.2 241.23 1631.2 245.258 1634.9 245.258C1638.5 245.258 1638.5 241.23 1642.2 241.23C1645.8 241.23 1645.8 245.258 1649.5 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 248.176C1616.6 248.176 1616.6 252.203 1620.3 252.203C1623.9 252.203 1623.9 248.176 1627.6 248.176C1631.2 248.176 1631.2 252.203 1634.9 252.203C1638.5 252.203 1638.5 248.176 1642.2 248.176C1645.8 248.176 1645.8 252.203 1649.5 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 283.619V239.518H1519.5L1525.2 249.587L1532.2 239.518H1553.9L1563 228.141L1579.3 283.619H1504.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 283.619V239.518H1519.5L1525.2 249.587L1532.2 239.518H1553.9L1563 228.141L1579.3 283.619H1504.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 211.327V167.226H1611.9L1617.6 177.396L1624.7 167.226H1646.3L1655.5 155.949L1671.7 211.327H1596.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.9 211.327V167.226H1611.9L1617.6 177.396L1624.7 167.226H1646.3L1655.5 155.949L1671.7 211.327H1596.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.7 198.842C1654.96 198.842 1657.6 196.182 1657.6 192.901C1657.6 189.621 1654.96 186.961 1651.7 186.961C1648.44 186.961 1645.8 189.621 1645.8 192.901C1645.8 196.182 1648.44 198.842 1651.7 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.5 198.336C1637.9 198.336 1637.9 194.309 1634.2 194.309C1630.6 194.309 1630.6 198.336 1626.9 198.336C1623.3 198.336 1623.3 194.309 1619.6 194.309C1616 194.309 1616 198.336 1612.3 198.336C1608.7 198.336 1608.7 194.309 1605 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.5 191.391C1637.9 191.391 1637.9 187.363 1634.2 187.363C1630.6 187.363 1630.6 191.391 1626.9 191.391C1623.3 191.391 1623.3 187.363 1619.6 187.363C1616 187.363 1616 191.391 1612.3 191.391C1608.7 191.391 1608.7 187.363 1605 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 83.3508V39.2497H1438.6L1444.3 49.4191L1451.4 39.2497H1473L1482.2 27.9727L1498.5 83.3508H1423.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 83.3508V39.2497H1438.6L1444.3 49.4191L1451.4 39.2497H1473L1482.2 27.9727L1498.5 83.3508H1423.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.4 -27.8086V16.2926H1469.4L1463.7 6.22382L1456.6 16.2926H1435L1425.8 27.6703L1409.5 -27.8086H1484.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.4 -27.8086V16.2926H1469.4L1463.7 6.22382L1456.6 16.2926H1435L1425.8 27.6703L1409.5 -27.8086H1484.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.2 27.6703V-16.4309H1346.2L1351.9 -6.36213L1359 -16.4309H1380.6L1389.8 -27.8086L1406 27.6703H1331.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.2 27.6703V-16.4309H1346.2L1351.9 -6.36213L1359 -16.4309H1380.6L1389.8 -27.8086L1406 27.6703H1331.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386 15.0843C1389.26 15.0843 1391.9 12.4246 1391.9 9.14369C1391.9 5.86281 1389.26 3.20312 1386 3.20312C1382.74 3.20312 1380.1 5.86281 1380.1 9.14369C1380.1 12.4246 1382.74 15.0843 1386 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.8 14.5822C1372.2 14.5822 1372.2 10.5547 1368.5 10.5547C1364.9 10.5547 1364.9 14.5822 1361.2 14.5822C1357.6 14.5822 1357.6 10.5547 1353.9 10.5547C1350.3 10.5547 1350.3 14.5822 1346.6 14.5822C1342.9 14.5822 1343 10.5547 1339.3 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.8 7.63688C1372.2 7.63688 1372.2 3.60938 1368.5 3.60938C1364.9 3.60938 1364.9 7.63688 1361.2 7.63688C1357.6 7.63688 1357.6 3.60938 1353.9 3.60938C1350.3 3.60938 1350.3 7.63688 1346.6 7.63688C1342.9 7.63688 1343 3.60938 1339.3 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 211.327V167.226H1438.6L1444.3 177.396L1451.4 167.226H1473L1482.2 155.949L1498.5 211.327H1423.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 211.327V167.226H1438.6L1444.3 177.396L1451.4 167.226H1473L1482.2 155.949L1498.5 211.327H1423.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 39.0508V83.1519H1391L1385.3 73.0832L1378.3 83.1519H1356.6L1347.5 94.5296L1331.2 39.0508H1406Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 39.0508V83.1519H1391L1385.3 73.0832L1378.3 83.1519H1356.6L1347.5 94.5296L1331.2 39.0508H1406Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.2 63.5178C1354.46 63.5178 1357.1 60.8582 1357.1 57.5773C1357.1 54.2964 1354.46 51.6367 1351.2 51.6367C1347.94 51.6367 1345.3 54.2964 1345.3 57.5773C1345.3 60.8582 1347.94 63.5178 1351.2 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.4 52.1406C1365 52.1406 1365 56.1681 1368.7 56.1681C1372.3 56.1681 1372.3 52.1406 1376 52.1406C1379.6 52.1406 1379.6 56.1681 1383.3 56.1681C1386.9 56.1681 1386.9 52.1406 1390.6 52.1406C1394.3 52.1406 1394.2 56.1681 1397.9 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.4 59.0859C1365 59.0859 1365 63.1134 1368.7 63.1134C1372.3 63.1134 1372.3 59.0859 1376 59.0859C1379.6 59.0859 1379.6 63.1134 1383.3 63.1134C1386.9 63.1134 1386.9 59.0859 1390.6 59.0859C1394.3 59.0859 1394.2 63.1134 1397.9 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.4 100.168V144.269H1469.4L1463.7 134.2L1456.6 144.269H1435L1425.8 155.647L1409.5 100.168H1484.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.4 100.168V144.269H1469.4L1463.7 134.2L1456.6 144.269H1435L1425.8 155.647L1409.5 100.168H1484.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.5 124.635C1432.76 124.635 1435.4 121.975 1435.4 118.694C1435.4 115.414 1432.76 112.754 1429.5 112.754C1426.24 112.754 1423.6 115.414 1423.6 118.694C1423.6 121.975 1426.24 124.635 1429.5 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.7 113.258C1443.3 113.258 1443.3 117.285 1447 117.285C1450.6 117.285 1450.6 113.258 1454.3 113.258C1457.9 113.258 1457.9 117.285 1461.6 117.285C1465.2 117.285 1465.2 113.258 1468.9 113.258C1472.6 113.258 1472.5 117.285 1476.2 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.7 120.203C1443.3 120.203 1443.3 124.231 1447 124.231C1450.6 124.231 1450.6 120.203 1454.3 120.203C1457.9 120.203 1457.9 124.231 1461.6 124.231C1465.2 124.231 1465.2 120.203 1468.9 120.203C1472.6 120.203 1472.5 124.231 1476.2 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.2 155.647V111.546H1346.2L1351.9 121.614L1359 111.546H1380.6L1389.8 100.168L1406 155.647H1331.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.2 155.647V111.546H1346.2L1351.9 121.614L1359 111.546H1380.6L1389.8 100.168L1406 155.647H1331.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386 143.061C1389.26 143.061 1391.9 140.401 1391.9 137.12C1391.9 133.839 1389.26 131.18 1386 131.18C1382.74 131.18 1380.1 133.839 1380.1 137.12C1380.1 140.401 1382.74 143.061 1386 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.8 142.555C1372.2 142.555 1372.2 138.527 1368.5 138.527C1364.9 138.527 1364.9 142.555 1361.2 142.555C1357.6 142.555 1357.6 138.527 1353.9 138.527C1350.3 138.527 1350.3 142.555 1346.6 142.555C1342.9 142.555 1343 138.527 1339.3 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.8 135.61C1372.2 135.61 1372.2 131.582 1368.5 131.582C1364.9 131.582 1364.9 135.61 1361.2 135.61C1357.6 135.61 1357.6 131.582 1353.9 131.582C1350.3 131.582 1350.3 135.61 1346.6 135.61C1342.9 135.61 1343 131.582 1339.3 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 83.3508V39.2497H1438.6L1444.3 49.4191L1451.4 39.2497H1473L1482.2 27.9727L1498.5 83.3508H1423.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 83.3508V39.2497H1438.6L1444.3 49.4191L1451.4 39.2497H1473L1482.2 27.9727L1498.5 83.3508H1423.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.5 70.8655C1481.76 70.8655 1484.4 68.2058 1484.4 64.925C1484.4 61.6441 1481.76 58.9844 1478.5 58.9844C1475.24 58.9844 1472.6 61.6441 1472.6 64.925C1472.6 68.2058 1475.24 70.8655 1478.5 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.3 70.3634C1464.7 70.3634 1464.7 66.3359 1461 66.3359C1457.4 66.3359 1457.4 70.3634 1453.7 70.3634C1450.1 70.3634 1450.1 66.3359 1446.4 66.3359C1442.8 66.3359 1442.8 70.3634 1439.1 70.3634C1435.4 70.3634 1435.5 66.3359 1431.8 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.3 63.4142C1464.7 63.4142 1464.7 59.3867 1461 59.3867C1457.4 59.3867 1457.4 63.4142 1453.7 63.4142C1450.1 63.4142 1450.1 59.3867 1446.4 59.3867C1442.8 59.3867 1442.8 63.4142 1439.1 63.4142C1435.4 63.4142 1435.5 59.3867 1431.8 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 167.023V211.125H1391L1385.3 201.056L1378.3 211.125H1356.6L1347.5 222.502L1331.2 167.023H1406Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 167.023V211.125H1391L1385.3 201.056L1378.3 211.125H1356.6L1347.5 222.502L1331.2 167.023H1406Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.2 191.49C1354.46 191.49 1357.1 188.831 1357.1 185.55C1357.1 182.269 1354.46 179.609 1351.2 179.609C1347.94 179.609 1345.3 182.269 1345.3 185.55C1345.3 188.831 1347.94 191.49 1351.2 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.4 180.113C1365 180.113 1365 184.141 1368.7 184.141C1372.3 184.141 1372.3 180.113 1376 180.113C1379.6 180.113 1379.6 184.141 1383.3 184.141C1386.9 184.141 1386.9 180.113 1390.6 180.113C1394.3 180.113 1394.2 184.141 1397.9 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.4 187.059C1365 187.059 1365 191.086 1368.7 191.086C1372.3 191.086 1372.3 187.059 1376 187.059C1379.6 187.059 1379.6 191.086 1383.3 191.086C1386.9 191.086 1386.9 187.059 1390.6 187.059C1394.3 187.059 1394.2 191.086 1397.9 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.4 228.141V272.242H1469.4L1463.7 262.173L1456.6 272.242H1435L1425.8 283.619L1409.5 228.141H1484.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.4 228.141V272.242H1469.4L1463.7 262.173L1456.6 272.242H1435L1425.8 283.619L1409.5 228.141H1484.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.5 252.608C1432.76 252.608 1435.4 249.948 1435.4 246.667C1435.4 243.386 1432.76 240.727 1429.5 240.727C1426.24 240.727 1423.6 243.386 1423.6 246.667C1423.6 249.948 1426.24 252.608 1429.5 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.7 241.23C1443.3 241.23 1443.3 245.258 1447 245.258C1450.6 245.258 1450.6 241.23 1454.3 241.23C1457.9 241.23 1457.9 245.258 1461.6 245.258C1465.2 245.258 1465.2 241.23 1468.9 241.23C1472.6 241.23 1472.5 245.258 1476.2 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.7 248.176C1443.3 248.176 1443.3 252.203 1447 252.203C1450.6 252.203 1450.6 248.176 1454.3 248.176C1457.9 248.176 1457.9 252.203 1461.6 252.203C1465.2 252.203 1465.2 248.176 1468.9 248.176C1472.6 248.176 1472.5 252.203 1476.2 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.2 283.619V239.518H1346.2L1351.9 249.587L1359 239.518H1380.6L1389.8 228.141L1406 283.619H1331.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.2 283.619V239.518H1346.2L1351.9 249.587L1359 239.518H1380.6L1389.8 228.141L1406 283.619H1331.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 211.327V167.226H1438.6L1444.3 177.396L1451.4 167.226H1473L1482.2 155.949L1498.5 211.327H1423.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 211.327V167.226H1438.6L1444.3 177.396L1451.4 167.226H1473L1482.2 155.949L1498.5 211.327H1423.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.5 198.842C1481.76 198.842 1484.4 196.182 1484.4 192.901C1484.4 189.621 1481.76 186.961 1478.5 186.961C1475.24 186.961 1472.6 189.621 1472.6 192.901C1472.6 196.182 1475.24 198.842 1478.5 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.3 198.336C1464.7 198.336 1464.7 194.309 1461 194.309C1457.4 194.309 1457.4 198.336 1453.7 198.336C1450.1 198.336 1450.1 194.309 1446.4 194.309C1442.8 194.309 1442.8 198.336 1439.1 198.336C1435.4 198.336 1435.5 194.309 1431.8 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.3 191.391C1464.7 191.391 1464.7 187.363 1461 187.363C1457.4 187.363 1457.4 191.391 1453.7 191.391C1450.1 191.391 1450.1 187.363 1446.4 187.363C1442.8 187.363 1442.8 191.391 1439.1 191.391C1435.4 191.391 1435.5 187.363 1431.8 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 83.3508V39.2497H1265.3L1271 49.4191L1278.1 39.2497H1299.7L1308.9 27.9727L1325.2 83.3508H1250.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 83.3508V39.2497H1265.3L1271 49.4191L1278.1 39.2497H1299.7L1308.9 27.9727L1325.2 83.3508H1250.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.1 -27.8086V16.2926H1296.1L1290.4 6.22382L1283.3 16.2926H1261.7L1252.5 27.6703L1236.2 -27.8086H1311.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.1 -27.8086V16.2926H1296.1L1290.4 6.22382L1283.3 16.2926H1261.7L1252.5 27.6703L1236.2 -27.8086H1311.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.9 27.6703V-16.4309H1172.9L1178.6 -6.36213L1185.7 -16.4309H1207.3L1216.5 -27.8086L1232.8 27.6703H1157.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.9 27.6703V-16.4309H1172.9L1178.6 -6.36213L1185.7 -16.4309H1207.3L1216.5 -27.8086L1232.8 27.6703H1157.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.8 15.0843C1216.06 15.0843 1218.7 12.4246 1218.7 9.14369C1218.7 5.86281 1216.06 3.20312 1212.8 3.20312C1209.54 3.20312 1206.9 5.86281 1206.9 9.14369C1206.9 12.4246 1209.54 15.0843 1212.8 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.6 14.5822C1199 14.5822 1199 10.5547 1195.3 10.5547C1191.7 10.5547 1191.7 14.5822 1188 14.5822C1184.4 14.5822 1184.4 10.5547 1180.7 10.5547C1177.1 10.5547 1177.1 14.5822 1173.4 14.5822C1169.8 14.5822 1169.8 10.5547 1166.1 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.6 7.63688C1199 7.63688 1199 3.60938 1195.3 3.60938C1191.7 3.60938 1191.7 7.63688 1188 7.63688C1184.4 7.63688 1184.4 3.60938 1180.7 3.60938C1177.1 3.60938 1177.1 7.63688 1173.4 7.63688C1169.8 7.63688 1169.8 3.60938 1166.1 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 211.327V167.226H1265.3L1271 177.396L1278.1 167.226H1299.7L1308.9 155.949L1325.2 211.327H1250.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 211.327V167.226H1265.3L1271 177.396L1278.1 167.226H1299.7L1308.9 155.949L1325.2 211.327H1250.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.8 39.0508V83.1519H1217.8L1212.1 73.0832L1205 83.1519H1183.4L1174.2 94.5296L1157.9 39.0508H1232.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.8 39.0508V83.1519H1217.8L1212.1 73.0832L1205 83.1519H1183.4L1174.2 94.5296L1157.9 39.0508H1232.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.9 63.5178C1181.16 63.5178 1183.8 60.8582 1183.8 57.5773C1183.8 54.2964 1181.16 51.6367 1177.9 51.6367C1174.64 51.6367 1172 54.2964 1172 57.5773C1172 60.8582 1174.64 63.5178 1177.9 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.1 52.1406C1191.7 52.1406 1191.7 56.1681 1195.4 56.1681C1199 56.1681 1199 52.1406 1202.7 52.1406C1206.3 52.1406 1206.3 56.1681 1210 56.1681C1213.6 56.1681 1213.6 52.1406 1217.3 52.1406C1220.9 52.1406 1220.9 56.1681 1224.6 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.1 59.0859C1191.7 59.0859 1191.7 63.1134 1195.4 63.1134C1199 63.1134 1199 59.0859 1202.7 59.0859C1206.3 59.0859 1206.3 63.1134 1210 63.1134C1213.6 63.1134 1213.6 59.0859 1217.3 59.0859C1220.9 59.0859 1220.9 63.1134 1224.6 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.1 100.168V144.269H1296.1L1290.4 134.2L1283.3 144.269H1261.7L1252.5 155.647L1236.2 100.168H1311.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.1 100.168V144.269H1296.1L1290.4 134.2L1283.3 144.269H1261.7L1252.5 155.647L1236.2 100.168H1311.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.3 124.635C1259.56 124.635 1262.2 121.975 1262.2 118.694C1262.2 115.414 1259.56 112.754 1256.3 112.754C1253.04 112.754 1250.4 115.414 1250.4 118.694C1250.4 121.975 1253.04 124.635 1256.3 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.4 113.258C1270 113.258 1270 117.285 1273.7 117.285C1277.3 117.285 1277.3 113.258 1281 113.258C1284.6 113.258 1284.6 117.285 1288.3 117.285C1291.9 117.285 1291.9 113.258 1295.6 113.258C1299.2 113.258 1299.2 117.285 1302.9 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.4 120.203C1270 120.203 1270 124.231 1273.7 124.231C1277.3 124.231 1277.3 120.203 1281 120.203C1284.6 120.203 1284.6 124.231 1288.3 124.231C1291.9 124.231 1291.9 120.203 1295.6 120.203C1299.2 120.203 1299.2 124.231 1302.9 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.9 155.647V111.546H1172.9L1178.6 121.614L1185.7 111.546H1207.3L1216.5 100.168L1232.8 155.647H1157.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.9 155.647V111.546H1172.9L1178.6 121.614L1185.7 111.546H1207.3L1216.5 100.168L1232.8 155.647H1157.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.8 143.061C1216.06 143.061 1218.7 140.401 1218.7 137.12C1218.7 133.839 1216.06 131.18 1212.8 131.18C1209.54 131.18 1206.9 133.839 1206.9 137.12C1206.9 140.401 1209.54 143.061 1212.8 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.6 142.555C1199 142.555 1199 138.527 1195.3 138.527C1191.7 138.527 1191.7 142.555 1188 142.555C1184.4 142.555 1184.4 138.527 1180.7 138.527C1177.1 138.527 1177.1 142.555 1173.4 142.555C1169.8 142.555 1169.8 138.527 1166.1 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.6 135.61C1199 135.61 1199 131.582 1195.3 131.582C1191.7 131.582 1191.7 135.61 1188 135.61C1184.4 135.61 1184.4 131.582 1180.7 131.582C1177.1 131.582 1177.1 135.61 1173.4 135.61C1169.8 135.61 1169.8 131.582 1166.1 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 83.3508V39.2497H1265.3L1271 49.4191L1278.1 39.2497H1299.7L1308.9 27.9727L1325.2 83.3508H1250.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 83.3508V39.2497H1265.3L1271 49.4191L1278.1 39.2497H1299.7L1308.9 27.9727L1325.2 83.3508H1250.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.2 70.8655C1308.46 70.8655 1311.1 68.2058 1311.1 64.925C1311.1 61.6441 1308.46 58.9844 1305.2 58.9844C1301.94 58.9844 1299.3 61.6441 1299.3 64.925C1299.3 68.2058 1301.94 70.8655 1305.2 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 70.3634C1291.4 70.3634 1291.4 66.3359 1287.7 66.3359C1284.1 66.3359 1284.1 70.3634 1280.4 70.3634C1276.8 70.3634 1276.8 66.3359 1273.1 66.3359C1269.5 66.3359 1269.5 70.3634 1265.8 70.3634C1262.2 70.3634 1262.2 66.3359 1258.5 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 63.4142C1291.4 63.4142 1291.4 59.3867 1287.7 59.3867C1284.1 59.3867 1284.1 63.4142 1280.4 63.4142C1276.8 63.4142 1276.8 59.3867 1273.1 59.3867C1269.5 59.3867 1269.5 63.4142 1265.8 63.4142C1262.2 63.4142 1262.2 59.3867 1258.5 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.8 167.023V211.125H1217.8L1212.1 201.056L1205 211.125H1183.4L1174.2 222.502L1157.9 167.023H1232.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.8 167.023V211.125H1217.8L1212.1 201.056L1205 211.125H1183.4L1174.2 222.502L1157.9 167.023H1232.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.9 191.49C1181.16 191.49 1183.8 188.831 1183.8 185.55C1183.8 182.269 1181.16 179.609 1177.9 179.609C1174.64 179.609 1172 182.269 1172 185.55C1172 188.831 1174.64 191.49 1177.9 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.1 180.113C1191.7 180.113 1191.7 184.141 1195.4 184.141C1199 184.141 1199 180.113 1202.7 180.113C1206.3 180.113 1206.3 184.141 1210 184.141C1213.6 184.141 1213.6 180.113 1217.3 180.113C1220.9 180.113 1220.9 184.141 1224.6 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.1 187.059C1191.7 187.059 1191.7 191.086 1195.4 191.086C1199 191.086 1199 187.059 1202.7 187.059C1206.3 187.059 1206.3 191.086 1210 191.086C1213.6 191.086 1213.6 187.059 1217.3 187.059C1220.9 187.059 1220.9 191.086 1224.6 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.1 228.141V272.242H1296.1L1290.4 262.173L1283.3 272.242H1261.7L1252.5 283.619L1236.2 228.141H1311.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.1 228.141V272.242H1296.1L1290.4 262.173L1283.3 272.242H1261.7L1252.5 283.619L1236.2 228.141H1311.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.3 252.608C1259.56 252.608 1262.2 249.948 1262.2 246.667C1262.2 243.386 1259.56 240.727 1256.3 240.727C1253.04 240.727 1250.4 243.386 1250.4 246.667C1250.4 249.948 1253.04 252.608 1256.3 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.4 241.23C1270 241.23 1270 245.258 1273.7 245.258C1277.3 245.258 1277.3 241.23 1281 241.23C1284.6 241.23 1284.6 245.258 1288.3 245.258C1291.9 245.258 1291.9 241.23 1295.6 241.23C1299.2 241.23 1299.2 245.258 1302.9 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.4 248.176C1270 248.176 1270 252.203 1273.7 252.203C1277.3 252.203 1277.3 248.176 1281 248.176C1284.6 248.176 1284.6 252.203 1288.3 252.203C1291.9 252.203 1291.9 248.176 1295.6 248.176C1299.2 248.176 1299.2 252.203 1302.9 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.9 283.619V239.518H1172.9L1178.6 249.587L1185.7 239.518H1207.3L1216.5 228.141L1232.8 283.619H1157.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.9 283.619V239.518H1172.9L1178.6 249.587L1185.7 239.518H1207.3L1216.5 228.141L1232.8 283.619H1157.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 211.327V167.226H1265.3L1271 177.396L1278.1 167.226H1299.7L1308.9 155.949L1325.2 211.327H1250.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.3 211.327V167.226H1265.3L1271 177.396L1278.1 167.226H1299.7L1308.9 155.949L1325.2 211.327H1250.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.2 198.842C1308.46 198.842 1311.1 196.182 1311.1 192.901C1311.1 189.621 1308.46 186.961 1305.2 186.961C1301.94 186.961 1299.3 189.621 1299.3 192.901C1299.3 196.182 1301.94 198.842 1305.2 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 198.336C1291.4 198.336 1291.4 194.309 1287.7 194.309C1284.1 194.309 1284.1 198.336 1280.4 198.336C1276.8 198.336 1276.8 194.309 1273.1 194.309C1269.5 194.309 1269.5 198.336 1265.8 198.336C1262.2 198.336 1262.2 194.309 1258.5 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 191.391C1291.4 191.391 1291.4 187.363 1287.7 187.363C1284.1 187.363 1284.1 191.391 1280.4 191.391C1276.8 191.391 1276.8 187.363 1273.1 187.363C1269.5 187.363 1269.5 191.391 1265.8 191.391C1262.2 191.391 1262.2 187.363 1258.5 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 83.3508V39.2497H1092.1L1097.8 49.4191L1104.8 39.2497H1126.5L1135.6 27.9727L1151.9 83.3508H1077.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 83.3508V39.2497H1092.1L1097.8 49.4191L1104.8 39.2497H1126.5L1135.6 27.9727L1151.9 83.3508H1077.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.8 -27.8086V16.2926H1122.8L1117.1 6.22382L1110.1 16.2926H1088.4L1079.2 27.6703L1063 -27.8086H1137.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.8 -27.8086V16.2926H1122.8L1117.1 6.22382L1110.1 16.2926H1088.4L1079.2 27.6703L1063 -27.8086H1137.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.6 27.6703V-16.4309H999.6L1005.3 -6.36213L1012.4 -16.4309H1034L1043.2 -27.8086L1059.5 27.6703H984.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.6 27.6703V-16.4309H999.6L1005.3 -6.36213L1012.4 -16.4309H1034L1043.2 -27.8086L1059.5 27.6703H984.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.5 15.0843C1042.76 15.0843 1045.4 12.4246 1045.4 9.14369C1045.4 5.86281 1042.76 3.20312 1039.5 3.20312C1036.24 3.20312 1033.6 5.86281 1033.6 9.14369C1033.6 12.4246 1036.24 15.0843 1039.5 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.3 14.5822C1025.7 14.5822 1025.7 10.5547 1022 10.5547C1018.4 10.5547 1018.4 14.5822 1014.7 14.5822C1011.1 14.5822 1011.1 10.5547 1007.4 10.5547C1003.8 10.5547 1003.8 14.5822 1000.1 14.5822C996.4 14.5822 996.5 10.5547 992.8 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.3 7.63688C1025.7 7.63688 1025.7 3.60938 1022 3.60938C1018.4 3.60938 1018.4 7.63688 1014.7 7.63688C1011.1 7.63688 1011.1 3.60938 1007.4 3.60938C1003.8 3.60938 1003.8 7.63688 1000.1 7.63688C996.4 7.63688 996.5 3.60938 992.8 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 211.327V167.226H1092.1L1097.8 177.396L1104.8 167.226H1126.5L1135.6 155.949L1151.9 211.327H1077.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 211.327V167.226H1092.1L1097.8 177.396L1104.8 167.226H1126.5L1135.6 155.949L1151.9 211.327H1077.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.5 39.0508V83.1519H1044.5L1038.8 73.0832L1031.7 83.1519H1010.1L1000.9 94.5296L984.6 39.0508H1059.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.5 39.0508V83.1519H1044.5L1038.8 73.0832L1031.7 83.1519H1010.1L1000.9 94.5296L984.6 39.0508H1059.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.6 63.5178C1007.86 63.5178 1010.5 60.8582 1010.5 57.5773C1010.5 54.2964 1007.86 51.6367 1004.6 51.6367C1001.34 51.6367 998.7 54.2964 998.7 57.5773C998.7 60.8582 1001.34 63.5178 1004.6 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.8 52.1406C1018.4 52.1406 1018.4 56.1681 1022.1 56.1681C1025.7 56.1681 1025.7 52.1406 1029.4 52.1406C1033 52.1406 1033 56.1681 1036.7 56.1681C1040.3 56.1681 1040.3 52.1406 1044 52.1406C1047.7 52.1406 1047.6 56.1681 1051.3 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.8 59.0859C1018.4 59.0859 1018.4 63.1134 1022.1 63.1134C1025.7 63.1134 1025.7 59.0859 1029.4 59.0859C1033 59.0859 1033 63.1134 1036.7 63.1134C1040.3 63.1134 1040.3 59.0859 1044 59.0859C1047.7 59.0859 1047.6 63.1134 1051.3 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.8 100.168V144.269H1122.8L1117.1 134.2L1110.1 144.269H1088.4L1079.2 155.647L1063 100.168H1137.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.8 100.168V144.269H1122.8L1117.1 134.2L1110.1 144.269H1088.4L1079.2 155.647L1063 100.168H1137.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 124.635C1086.26 124.635 1088.9 121.975 1088.9 118.694C1088.9 115.414 1086.26 112.754 1083 112.754C1079.74 112.754 1077.1 115.414 1077.1 118.694C1077.1 121.975 1079.74 124.635 1083 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.2 113.258C1096.8 113.258 1096.8 117.285 1100.5 117.285C1104.1 117.285 1104.1 113.258 1107.8 113.258C1111.4 113.258 1111.4 117.285 1115.1 117.285C1118.7 117.285 1118.7 113.258 1122.4 113.258C1126 113.258 1126 117.285 1129.7 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.2 120.203C1096.8 120.203 1096.8 124.231 1100.5 124.231C1104.1 124.231 1104.1 120.203 1107.8 120.203C1111.4 120.203 1111.4 124.231 1115.1 124.231C1118.7 124.231 1118.7 120.203 1122.4 120.203C1126 120.203 1126 124.231 1129.7 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.6 155.647V111.546H999.6L1005.3 121.614L1012.4 111.546H1034L1043.2 100.168L1059.5 155.647H984.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.6 155.647V111.546H999.6L1005.3 121.614L1012.4 111.546H1034L1043.2 100.168L1059.5 155.647H984.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.5 143.061C1042.76 143.061 1045.4 140.401 1045.4 137.12C1045.4 133.839 1042.76 131.18 1039.5 131.18C1036.24 131.18 1033.6 133.839 1033.6 137.12C1033.6 140.401 1036.24 143.061 1039.5 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.3 142.555C1025.7 142.555 1025.7 138.527 1022 138.527C1018.4 138.527 1018.4 142.555 1014.7 142.555C1011.1 142.555 1011.1 138.527 1007.4 138.527C1003.8 138.527 1003.8 142.555 1000.1 142.555C996.4 142.555 996.5 138.527 992.8 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.3 135.61C1025.7 135.61 1025.7 131.582 1022 131.582C1018.4 131.582 1018.4 135.61 1014.7 135.61C1011.1 135.61 1011.1 131.582 1007.4 131.582C1003.8 131.582 1003.8 135.61 1000.1 135.61C996.4 135.61 996.5 131.582 992.8 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 83.3508V39.2497H1092.1L1097.8 49.4191L1104.8 39.2497H1126.5L1135.6 27.9727L1151.9 83.3508H1077.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 83.3508V39.2497H1092.1L1097.8 49.4191L1104.8 39.2497H1126.5L1135.6 27.9727L1151.9 83.3508H1077.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.9 70.8655C1135.16 70.8655 1137.8 68.2058 1137.8 64.925C1137.8 61.6441 1135.16 58.9844 1131.9 58.9844C1128.64 58.9844 1126 61.6441 1126 64.925C1126 68.2058 1128.64 70.8655 1131.9 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.7 70.3634C1118.1 70.3634 1118.1 66.3359 1114.4 66.3359C1110.8 66.3359 1110.8 70.3634 1107.1 70.3634C1103.5 70.3634 1103.5 66.3359 1099.8 66.3359C1096.2 66.3359 1096.2 70.3634 1092.5 70.3634C1088.8 70.3634 1088.9 66.3359 1085.2 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.7 63.4142C1118.1 63.4142 1118.1 59.3867 1114.4 59.3867C1110.8 59.3867 1110.8 63.4142 1107.1 63.4142C1103.5 63.4142 1103.5 59.3867 1099.8 59.3867C1096.2 59.3867 1096.2 63.4142 1092.5 63.4142C1088.8 63.4142 1088.9 59.3867 1085.2 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.5 167.023V211.125H1044.5L1038.8 201.056L1031.7 211.125H1010.1L1000.9 222.502L984.6 167.023H1059.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.5 167.023V211.125H1044.5L1038.8 201.056L1031.7 211.125H1010.1L1000.9 222.502L984.6 167.023H1059.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.6 191.49C1007.86 191.49 1010.5 188.831 1010.5 185.55C1010.5 182.269 1007.86 179.609 1004.6 179.609C1001.34 179.609 998.7 182.269 998.7 185.55C998.7 188.831 1001.34 191.49 1004.6 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.8 180.113C1018.4 180.113 1018.4 184.141 1022.1 184.141C1025.7 184.141 1025.7 180.113 1029.4 180.113C1033 180.113 1033 184.141 1036.7 184.141C1040.3 184.141 1040.3 180.113 1044 180.113C1047.7 180.113 1047.6 184.141 1051.3 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.8 187.059C1018.4 187.059 1018.4 191.086 1022.1 191.086C1025.7 191.086 1025.7 187.059 1029.4 187.059C1033 187.059 1033 191.086 1036.7 191.086C1040.3 191.086 1040.3 187.059 1044 187.059C1047.7 187.059 1047.6 191.086 1051.3 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.8 228.141V272.242H1122.8L1117.1 262.173L1110.1 272.242H1088.4L1079.2 283.619L1063 228.141H1137.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.8 228.141V272.242H1122.8L1117.1 262.173L1110.1 272.242H1088.4L1079.2 283.619L1063 228.141H1137.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 252.608C1086.26 252.608 1088.9 249.948 1088.9 246.667C1088.9 243.386 1086.26 240.727 1083 240.727C1079.74 240.727 1077.1 243.386 1077.1 246.667C1077.1 249.948 1079.74 252.608 1083 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.2 241.23C1096.8 241.23 1096.8 245.258 1100.5 245.258C1104.1 245.258 1104.1 241.23 1107.8 241.23C1111.4 241.23 1111.4 245.258 1115.1 245.258C1118.7 245.258 1118.7 241.23 1122.4 241.23C1126 241.23 1126 245.258 1129.7 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.2 248.176C1096.8 248.176 1096.8 252.203 1100.5 252.203C1104.1 252.203 1104.1 248.176 1107.8 248.176C1111.4 248.176 1111.4 252.203 1115.1 252.203C1118.7 252.203 1118.7 248.176 1122.4 248.176C1126 248.176 1126 252.203 1129.7 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.6 283.619V239.518H999.6L1005.3 249.587L1012.4 239.518H1034L1043.2 228.141L1059.5 283.619H984.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.6 283.619V239.518H999.6L1005.3 249.587L1012.4 239.518H1034L1043.2 228.141L1059.5 283.619H984.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 211.327V167.226H1092.1L1097.8 177.396L1104.8 167.226H1126.5L1135.6 155.949L1151.9 211.327H1077.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1 211.327V167.226H1092.1L1097.8 177.396L1104.8 167.226H1126.5L1135.6 155.949L1151.9 211.327H1077.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.9 198.842C1135.16 198.842 1137.8 196.182 1137.8 192.901C1137.8 189.621 1135.16 186.961 1131.9 186.961C1128.64 186.961 1126 189.621 1126 192.901C1126 196.182 1128.64 198.842 1131.9 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.7 198.336C1118.1 198.336 1118.1 194.309 1114.4 194.309C1110.8 194.309 1110.8 198.336 1107.1 198.336C1103.5 198.336 1103.5 194.309 1099.8 194.309C1096.2 194.309 1096.2 198.336 1092.5 198.336C1088.8 198.336 1088.9 194.309 1085.2 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.7 191.391C1118.1 191.391 1118.1 187.363 1114.4 187.363C1110.8 187.363 1110.8 191.391 1107.1 191.391C1103.5 191.391 1103.5 187.363 1099.8 187.363C1096.2 187.363 1096.2 191.391 1092.5 191.391C1088.8 191.391 1088.9 187.363 1085.2 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 83.3508V39.2497H918.8L924.5 49.4191L931.6 39.2497H953.2L962.4 27.9727L978.6 83.3508H903.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 83.3508V39.2497H918.8L924.5 49.4191L931.6 39.2497H953.2L962.4 27.9727L978.6 83.3508H903.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.6 -27.8086V16.2926H949.6L943.8 6.22382L936.8 16.2926H915.1L906 27.6703L889.7 -27.8086H964.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.6 -27.8086V16.2926H949.6L943.8 6.22382L936.8 16.2926H915.1L906 27.6703L889.7 -27.8086H964.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.4 27.6703V-16.4309H826.4L832.1 -6.36213L839.1 -16.4309H860.8L869.9 -27.8086L886.2 27.6703H811.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.4 27.6703V-16.4309H826.4L832.1 -6.36213L839.1 -16.4309H860.8L869.9 -27.8086L886.2 27.6703H811.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.2 15.0843C869.459 15.0843 872.1 12.4246 872.1 9.14369C872.1 5.86281 869.459 3.20312 866.2 3.20312C862.942 3.20312 860.3 5.86281 860.3 9.14369C860.3 12.4246 862.942 15.0843 866.2 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 14.5822C852.4 14.5822 852.4 10.5547 848.7 10.5547C845.1 10.5547 845.1 14.5822 841.4 14.5822C837.8 14.5822 837.8 10.5547 834.1 10.5547C830.5 10.5547 830.5 14.5822 826.8 14.5822C823.2 14.5822 823.2 10.5547 819.5 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 7.63688C852.4 7.63688 852.4 3.60938 848.7 3.60938C845.1 3.60938 845.1 7.63688 841.4 7.63688C837.8 7.63688 837.8 3.60938 834.1 3.60938C830.5 3.60938 830.5 7.63688 826.8 7.63688C823.2 7.63688 823.2 3.60938 819.5 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 211.327V167.226H918.8L924.5 177.396L931.6 167.226H953.2L962.4 155.949L978.6 211.327H903.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 211.327V167.226H918.8L924.5 177.396L931.6 167.226H953.2L962.4 155.949L978.6 211.327H903.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.2 39.0508V83.1519H871.2L865.5 73.0832L858.4 83.1519H836.8L827.6 94.5296L811.4 39.0508H886.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.2 39.0508V83.1519H871.2L865.5 73.0832L858.4 83.1519H836.8L827.6 94.5296L811.4 39.0508H886.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.4 63.5178C834.659 63.5178 837.3 60.8582 837.3 57.5773C837.3 54.2964 834.659 51.6367 831.4 51.6367C828.142 51.6367 825.5 54.2964 825.5 57.5773C825.5 60.8582 828.142 63.5178 831.4 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.6 52.1406C845.2 52.1406 845.2 56.1681 848.9 56.1681C852.5 56.1681 852.5 52.1406 856.2 52.1406C859.8 52.1406 859.8 56.1681 863.5 56.1681C867.1 56.1681 867.1 52.1406 870.8 52.1406C874.4 52.1406 874.4 56.1681 878.1 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.6 59.0859C845.2 59.0859 845.2 63.1134 848.9 63.1134C852.5 63.1134 852.5 59.0859 856.2 59.0859C859.8 59.0859 859.8 63.1134 863.5 63.1134C867.1 63.1134 867.1 59.0859 870.8 59.0859C874.4 59.0859 874.4 63.1134 878.1 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.6 100.168V144.269H949.6L943.8 134.2L936.8 144.269H915.1L906 155.647L889.7 100.168H964.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.6 100.168V144.269H949.6L943.8 134.2L936.8 144.269H915.1L906 155.647L889.7 100.168H964.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.7 124.635C912.959 124.635 915.6 121.975 915.6 118.694C915.6 115.414 912.959 112.754 909.7 112.754C906.442 112.754 903.8 115.414 903.8 118.694C903.8 121.975 906.442 124.635 909.7 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.9 113.258C923.5 113.258 923.5 117.285 927.2 117.285C930.8 117.285 930.8 113.258 934.5 113.258C938.1 113.258 938.1 117.285 941.8 117.285C945.4 117.285 945.4 113.258 949.1 113.258C952.7 113.258 952.7 117.285 956.4 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.9 120.203C923.5 120.203 923.5 124.231 927.2 124.231C930.8 124.231 930.8 120.203 934.5 120.203C938.1 120.203 938.1 124.231 941.8 124.231C945.4 124.231 945.4 120.203 949.1 120.203C952.7 120.203 952.7 124.231 956.4 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.4 155.647V111.546H826.4L832.1 121.614L839.1 111.546H860.8L869.9 100.168L886.2 155.647H811.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.4 155.647V111.546H826.4L832.1 121.614L839.1 111.546H860.8L869.9 100.168L886.2 155.647H811.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.2 143.061C869.459 143.061 872.1 140.401 872.1 137.12C872.1 133.839 869.459 131.18 866.2 131.18C862.942 131.18 860.3 133.839 860.3 137.12C860.3 140.401 862.942 143.061 866.2 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 142.555C852.4 142.555 852.4 138.527 848.7 138.527C845.1 138.527 845.1 142.555 841.4 142.555C837.8 142.555 837.8 138.527 834.1 138.527C830.5 138.527 830.5 142.555 826.8 142.555C823.2 142.555 823.2 138.527 819.5 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 135.61C852.4 135.61 852.4 131.582 848.7 131.582C845.1 131.582 845.1 135.61 841.4 135.61C837.8 135.61 837.8 131.582 834.1 131.582C830.5 131.582 830.5 135.61 826.8 135.61C823.2 135.61 823.2 131.582 819.5 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 83.3508V39.2497H918.8L924.5 49.4191L931.6 39.2497H953.2L962.4 27.9727L978.6 83.3508H903.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 83.3508V39.2497H918.8L924.5 49.4191L931.6 39.2497H953.2L962.4 27.9727L978.6 83.3508H903.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.6 70.8655C961.858 70.8655 964.5 68.2058 964.5 64.925C964.5 61.6441 961.858 58.9844 958.6 58.9844C955.341 58.9844 952.7 61.6441 952.7 64.925C952.7 68.2058 955.341 70.8655 958.6 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.4 70.3634C944.8 70.3634 944.8 66.3359 941.1 66.3359C937.5 66.3359 937.5 70.3634 933.8 70.3634C930.2 70.3634 930.2 66.3359 926.5 66.3359C922.9 66.3359 922.9 70.3634 919.2 70.3634C915.6 70.3634 915.6 66.3359 911.9 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.4 63.4142C944.8 63.4142 944.8 59.3867 941.1 59.3867C937.5 59.3867 937.5 63.4142 933.8 63.4142C930.2 63.4142 930.2 59.3867 926.5 59.3867C922.9 59.3867 922.9 63.4142 919.2 63.4142C915.6 63.4142 915.6 59.3867 911.9 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.2 167.023V211.125H871.2L865.5 201.056L858.4 211.125H836.8L827.6 222.502L811.4 167.023H886.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.2 167.023V211.125H871.2L865.5 201.056L858.4 211.125H836.8L827.6 222.502L811.4 167.023H886.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.4 191.49C834.659 191.49 837.3 188.831 837.3 185.55C837.3 182.269 834.659 179.609 831.4 179.609C828.142 179.609 825.5 182.269 825.5 185.55C825.5 188.831 828.142 191.49 831.4 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.6 180.113C845.2 180.113 845.2 184.141 848.9 184.141C852.5 184.141 852.5 180.113 856.2 180.113C859.8 180.113 859.8 184.141 863.5 184.141C867.1 184.141 867.1 180.113 870.8 180.113C874.4 180.113 874.4 184.141 878.1 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.6 187.059C845.2 187.059 845.2 191.086 848.9 191.086C852.5 191.086 852.5 187.059 856.2 187.059C859.8 187.059 859.8 191.086 863.5 191.086C867.1 191.086 867.1 187.059 870.8 187.059C874.4 187.059 874.4 191.086 878.1 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.6 228.141V272.242H949.6L943.8 262.173L936.8 272.242H915.1L906 283.619L889.7 228.141H964.6Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.6 228.141V272.242H949.6L943.8 262.173L936.8 272.242H915.1L906 283.619L889.7 228.141H964.6Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.7 252.608C912.959 252.608 915.6 249.948 915.6 246.667C915.6 243.386 912.959 240.727 909.7 240.727C906.442 240.727 903.8 243.386 903.8 246.667C903.8 249.948 906.442 252.608 909.7 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.9 241.23C923.5 241.23 923.5 245.258 927.2 245.258C930.8 245.258 930.8 241.23 934.5 241.23C938.1 241.23 938.1 245.258 941.8 245.258C945.4 245.258 945.4 241.23 949.1 241.23C952.7 241.23 952.7 245.258 956.4 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.9 248.176C923.5 248.176 923.5 252.203 927.2 252.203C930.8 252.203 930.8 248.176 934.5 248.176C938.1 248.176 938.1 252.203 941.8 252.203C945.4 252.203 945.4 248.176 949.1 248.176C952.7 248.176 952.7 252.203 956.4 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.4 283.619V239.518H826.4L832.1 249.587L839.1 239.518H860.8L869.9 228.141L886.2 283.619H811.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.4 283.619V239.518H826.4L832.1 249.587L839.1 239.518H860.8L869.9 228.141L886.2 283.619H811.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 211.327V167.226H918.8L924.5 177.396L931.6 167.226H953.2L962.4 155.949L978.6 211.327H903.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.8 211.327V167.226H918.8L924.5 177.396L931.6 167.226H953.2L962.4 155.949L978.6 211.327H903.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.6 198.842C961.858 198.842 964.5 196.182 964.5 192.901C964.5 189.621 961.858 186.961 958.6 186.961C955.341 186.961 952.7 189.621 952.7 192.901C952.7 196.182 955.341 198.842 958.6 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.4 198.336C944.8 198.336 944.8 194.309 941.1 194.309C937.5 194.309 937.5 198.336 933.8 198.336C930.2 198.336 930.2 194.309 926.5 194.309C922.9 194.309 922.9 198.336 919.2 198.336C915.6 198.336 915.6 194.309 911.9 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.4 191.391C944.8 191.391 944.8 187.363 941.1 187.363C937.5 187.363 937.5 191.391 933.8 191.391C930.2 191.391 930.2 187.363 926.5 187.363C922.9 187.363 922.9 191.391 919.2 191.391C915.6 191.391 915.6 187.363 911.9 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 83.3508V39.2497H745.5L751.2 49.4191L758.3 39.2497H779.9L789.1 27.9727L805.4 83.3508H730.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 83.3508V39.2497H745.5L751.2 49.4191L758.3 39.2497H779.9L789.1 27.9727L805.4 83.3508H730.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.3 -27.8086V16.2926H776.3L770.6 6.22382L763.5 16.2926H741.9L732.7 27.6703L716.4 -27.8086H791.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.3 -27.8086V16.2926H776.3L770.6 6.22382L763.5 16.2926H741.9L732.7 27.6703L716.4 -27.8086H791.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.1 27.6703V-16.4309H653.1L658.8 -6.36213L665.9 -16.4309H687.5L696.7 -27.8086L712.9 27.6703H638.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.1 27.6703V-16.4309H653.1L658.8 -6.36213L665.9 -16.4309H687.5L696.7 -27.8086L712.9 27.6703H638.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.9 15.0843C696.159 15.0843 698.8 12.4246 698.8 9.14369C698.8 5.86281 696.159 3.20312 692.9 3.20312C689.642 3.20312 687 5.86281 687 9.14369C687 12.4246 689.642 15.0843 692.9 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.8 14.5822C679.2 14.5822 679.2 10.5547 675.5 10.5547C671.9 10.5547 671.9 14.5822 668.2 14.5822C664.6 14.5822 664.6 10.5547 660.9 10.5547C657.3 10.5547 657.3 14.5822 653.6 14.5822C650 14.5822 650 10.5547 646.3 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.8 7.63688C679.2 7.63688 679.2 3.60938 675.5 3.60938C671.9 3.60938 671.9 7.63688 668.2 7.63688C664.6 7.63688 664.6 3.60938 660.9 3.60938C657.3 3.60938 657.3 7.63688 653.6 7.63688C650 7.63688 650 3.60938 646.3 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 211.327V167.226H745.5L751.2 177.396L758.3 167.226H779.9L789.1 155.949L805.4 211.327H730.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 211.327V167.226H745.5L751.2 177.396L758.3 167.226H779.9L789.1 155.949L805.4 211.327H730.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.9 39.0508V83.1519H697.9L692.2 73.0832L685.2 83.1519H663.5L654.4 94.5296L638.1 39.0508H712.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.9 39.0508V83.1519H697.9L692.2 73.0832L685.2 83.1519H663.5L654.4 94.5296L638.1 39.0508H712.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.1 63.5178C661.358 63.5178 664 60.8582 664 57.5773C664 54.2964 661.358 51.6367 658.1 51.6367C654.841 51.6367 652.2 54.2964 652.2 57.5773C652.2 60.8582 654.841 63.5178 658.1 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.3 52.1406C671.9 52.1406 671.9 56.1681 675.6 56.1681C679.2 56.1681 679.2 52.1406 682.9 52.1406C686.5 52.1406 686.5 56.1681 690.2 56.1681C693.8 56.1681 693.8 52.1406 697.5 52.1406C701.1 52.1406 701.1 56.1681 704.8 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.3 59.0859C671.9 59.0859 671.9 63.1134 675.6 63.1134C679.2 63.1134 679.2 59.0859 682.9 59.0859C686.5 59.0859 686.5 63.1134 690.2 63.1134C693.8 63.1134 693.8 59.0859 697.5 59.0859C701.1 59.0859 701.1 63.1134 704.8 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.3 100.168V144.269H776.3L770.6 134.2L763.5 144.269H741.9L732.7 155.647L716.4 100.168H791.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.3 100.168V144.269H776.3L770.6 134.2L763.5 144.269H741.9L732.7 155.647L716.4 100.168H791.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.4 124.635C739.659 124.635 742.3 121.975 742.3 118.694C742.3 115.414 739.659 112.754 736.4 112.754C733.142 112.754 730.5 115.414 730.5 118.694C730.5 121.975 733.142 124.635 736.4 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.6 113.258C750.2 113.258 750.2 117.285 753.9 117.285C757.5 117.285 757.5 113.258 761.2 113.258C764.8 113.258 764.8 117.285 768.5 117.285C772.1 117.285 772.1 113.258 775.8 113.258C779.4 113.258 779.4 117.285 783.1 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.6 120.203C750.2 120.203 750.2 124.231 753.9 124.231C757.5 124.231 757.5 120.203 761.2 120.203C764.8 120.203 764.8 124.231 768.5 124.231C772.1 124.231 772.1 120.203 775.8 120.203C779.4 120.203 779.4 124.231 783.1 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.1 155.647V111.546H653.1L658.8 121.614L665.9 111.546H687.5L696.7 100.168L712.9 155.647H638.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.1 155.647V111.546H653.1L658.8 121.614L665.9 111.546H687.5L696.7 100.168L712.9 155.647H638.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.9 143.061C696.159 143.061 698.8 140.401 698.8 137.12C698.8 133.839 696.159 131.18 692.9 131.18C689.642 131.18 687 133.839 687 137.12C687 140.401 689.642 143.061 692.9 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.8 142.555C679.2 142.555 679.2 138.527 675.5 138.527C671.9 138.527 671.9 142.555 668.2 142.555C664.6 142.555 664.6 138.527 660.9 138.527C657.3 138.527 657.3 142.555 653.6 142.555C650 142.555 650 138.527 646.3 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.8 135.61C679.2 135.61 679.2 131.582 675.5 131.582C671.9 131.582 671.9 135.61 668.2 135.61C664.6 135.61 664.6 131.582 660.9 131.582C657.3 131.582 657.3 135.61 653.6 135.61C650 135.61 650 131.582 646.3 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 83.3508V39.2497H745.5L751.2 49.4191L758.3 39.2497H779.9L789.1 27.9727L805.4 83.3508H730.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 83.3508V39.2497H745.5L751.2 49.4191L758.3 39.2497H779.9L789.1 27.9727L805.4 83.3508H730.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.4 70.8655C788.659 70.8655 791.3 68.2058 791.3 64.925C791.3 61.6441 788.659 58.9844 785.4 58.9844C782.142 58.9844 779.5 61.6441 779.5 64.925C779.5 68.2058 782.142 70.8655 785.4 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.2 70.3634C771.6 70.3634 771.6 66.3359 767.9 66.3359C764.3 66.3359 764.3 70.3634 760.6 70.3634C757 70.3634 757 66.3359 753.3 66.3359C749.7 66.3359 749.7 70.3634 746 70.3634C742.4 70.3634 742.4 66.3359 738.7 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.2 63.4142C771.6 63.4142 771.6 59.3867 767.9 59.3867C764.3 59.3867 764.3 63.4142 760.6 63.4142C757 63.4142 757 59.3867 753.3 59.3867C749.7 59.3867 749.7 63.4142 746 63.4142C742.4 63.4142 742.4 59.3867 738.7 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.9 167.023V211.125H697.9L692.2 201.056L685.2 211.125H663.5L654.4 222.502L638.1 167.023H712.9Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.9 167.023V211.125H697.9L692.2 201.056L685.2 211.125H663.5L654.4 222.502L638.1 167.023H712.9Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.1 191.49C661.358 191.49 664 188.831 664 185.55C664 182.269 661.358 179.609 658.1 179.609C654.841 179.609 652.2 182.269 652.2 185.55C652.2 188.831 654.841 191.49 658.1 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.3 180.113C671.9 180.113 671.9 184.141 675.6 184.141C679.2 184.141 679.2 180.113 682.9 180.113C686.5 180.113 686.5 184.141 690.2 184.141C693.8 184.141 693.8 180.113 697.5 180.113C701.1 180.113 701.1 184.141 704.8 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.3 187.059C671.9 187.059 671.9 191.086 675.6 191.086C679.2 191.086 679.2 187.059 682.9 187.059C686.5 187.059 686.5 191.086 690.2 191.086C693.8 191.086 693.8 187.059 697.5 187.059C701.1 187.059 701.1 191.086 704.8 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.3 228.141V272.242H776.3L770.6 262.173L763.5 272.242H741.9L732.7 283.619L716.4 228.141H791.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.3 228.141V272.242H776.3L770.6 262.173L763.5 272.242H741.9L732.7 283.619L716.4 228.141H791.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.4 252.608C739.659 252.608 742.3 249.948 742.3 246.667C742.3 243.386 739.659 240.727 736.4 240.727C733.142 240.727 730.5 243.386 730.5 246.667C730.5 249.948 733.142 252.608 736.4 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.6 241.23C750.2 241.23 750.2 245.258 753.9 245.258C757.5 245.258 757.5 241.23 761.2 241.23C764.8 241.23 764.8 245.258 768.5 245.258C772.1 245.258 772.1 241.23 775.8 241.23C779.4 241.23 779.4 245.258 783.1 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.6 248.176C750.2 248.176 750.2 252.203 753.9 252.203C757.5 252.203 757.5 248.176 761.2 248.176C764.8 248.176 764.8 252.203 768.5 252.203C772.1 252.203 772.1 248.176 775.8 248.176C779.4 248.176 779.4 252.203 783.1 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.1 283.619V239.518H653.1L658.8 249.587L665.9 239.518H687.5L696.7 228.141L712.9 283.619H638.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.1 283.619V239.518H653.1L658.8 249.587L665.9 239.518H687.5L696.7 228.141L712.9 283.619H638.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 211.327V167.226H745.5L751.2 177.396L758.3 167.226H779.9L789.1 155.949L805.4 211.327H730.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.5 211.327V167.226H745.5L751.2 177.396L758.3 167.226H779.9L789.1 155.949L805.4 211.327H730.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.4 198.842C788.659 198.842 791.3 196.182 791.3 192.901C791.3 189.621 788.659 186.961 785.4 186.961C782.142 186.961 779.5 189.621 779.5 192.901C779.5 196.182 782.142 198.842 785.4 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.2 198.336C771.6 198.336 771.6 194.309 767.9 194.309C764.3 194.309 764.3 198.336 760.6 198.336C757 198.336 757 194.309 753.3 194.309C749.7 194.309 749.7 198.336 746 198.336C742.4 198.336 742.4 194.309 738.7 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.2 191.391C771.6 191.391 771.6 187.363 767.9 187.363C764.3 187.363 764.3 191.391 760.6 191.391C757 191.391 757 187.363 753.3 187.363C749.7 187.363 749.7 191.391 746 191.391C742.4 191.391 742.4 187.363 738.7 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 83.3508V39.2497H572.2L578 49.4191L585 39.2497H606.7L615.8 27.9727L632.1 83.3508H557.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 83.3508V39.2497H572.2L578 49.4191L585 39.2497H606.7L615.8 27.9727L632.1 83.3508H557.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 -27.8086V16.2926H603L597.3 6.22382L590.2 16.2926H568.6L559.4 27.6703L543.2 -27.8086H618Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 -27.8086V16.2926H603L597.3 6.22382L590.2 16.2926H568.6L559.4 27.6703L543.2 -27.8086H618Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8 27.6703V-16.4309H479.8L485.5 -6.36213L492.6 -16.4309H514.2L523.4 -27.8086L539.7 27.6703H464.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8 27.6703V-16.4309H479.8L485.5 -6.36213L492.6 -16.4309H514.2L523.4 -27.8086L539.7 27.6703H464.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.7 15.0843C522.959 15.0843 525.6 12.4246 525.6 9.14369C525.6 5.86281 522.959 3.20312 519.7 3.20312C516.442 3.20312 513.8 5.86281 513.8 9.14369C513.8 12.4246 516.442 15.0843 519.7 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 14.5822C505.9 14.5822 505.9 10.5547 502.2 10.5547C498.6 10.5547 498.6 14.5822 494.9 14.5822C491.3 14.5822 491.3 10.5547 487.6 10.5547C484 10.5547 484 14.5822 480.3 14.5822C476.6 14.5822 476.7 10.5547 473 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 7.63688C505.9 7.63688 505.9 3.60938 502.2 3.60938C498.6 3.60938 498.6 7.63688 494.9 7.63688C491.3 7.63688 491.3 3.60938 487.6 3.60938C484 3.60938 484 7.63688 480.3 7.63688C476.6 7.63688 476.7 3.60938 473 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 211.327V167.226H572.2L578 177.396L585 167.226H606.7L615.8 155.949L632.1 211.327H557.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 211.327V167.226H572.2L578 177.396L585 167.226H606.7L615.8 155.949L632.1 211.327H557.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.7 39.0508V83.1519H524.7L519 73.0832L511.9 83.1519H490.3L481.1 94.5296L464.8 39.0508H539.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.7 39.0508V83.1519H524.7L519 73.0832L511.9 83.1519H490.3L481.1 94.5296L464.8 39.0508H539.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.8 63.5178C488.058 63.5178 490.7 60.8582 490.7 57.5773C490.7 54.2964 488.058 51.6367 484.8 51.6367C481.541 51.6367 478.9 54.2964 478.9 57.5773C478.9 60.8582 481.541 63.5178 484.8 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 52.1406C498.6 52.1406 498.6 56.1681 502.3 56.1681C505.9 56.1681 505.9 52.1406 509.6 52.1406C513.2 52.1406 513.2 56.1681 516.9 56.1681C520.5 56.1681 520.5 52.1406 524.2 52.1406C527.8 52.1406 527.8 56.1681 531.5 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 59.0859C498.6 59.0859 498.6 63.1134 502.3 63.1134C505.9 63.1134 505.9 59.0859 509.6 59.0859C513.2 59.0859 513.2 63.1134 516.9 63.1134C520.5 63.1134 520.5 59.0859 524.2 59.0859C527.8 59.0859 527.8 63.1134 531.5 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 100.168V144.269H603L597.3 134.2L590.2 144.269H568.6L559.4 155.647L543.2 100.168H618Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 100.168V144.269H603L597.3 134.2L590.2 144.269H568.6L559.4 155.647L543.2 100.168H618Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.2 124.635C566.459 124.635 569.1 121.975 569.1 118.694C569.1 115.414 566.459 112.754 563.2 112.754C559.942 112.754 557.3 115.414 557.3 118.694C557.3 121.975 559.942 124.635 563.2 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.3 113.258C576.9 113.258 576.9 117.285 580.6 117.285C584.2 117.285 584.2 113.258 587.9 113.258C591.5 113.258 591.5 117.285 595.2 117.285C598.8 117.285 598.8 113.258 602.5 113.258C606.2 113.258 606.1 117.285 609.8 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.3 120.203C576.9 120.203 576.9 124.231 580.6 124.231C584.2 124.231 584.2 120.203 587.9 120.203C591.5 120.203 591.5 124.231 595.2 124.231C598.8 124.231 598.8 120.203 602.5 120.203C606.2 120.203 606.1 124.231 609.8 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8 155.647V111.546H479.8L485.5 121.614L492.6 111.546H514.2L523.4 100.168L539.7 155.647H464.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8 155.647V111.546H479.8L485.5 121.614L492.6 111.546H514.2L523.4 100.168L539.7 155.647H464.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.7 143.061C522.959 143.061 525.6 140.401 525.6 137.12C525.6 133.839 522.959 131.18 519.7 131.18C516.442 131.18 513.8 133.839 513.8 137.12C513.8 140.401 516.442 143.061 519.7 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 142.555C505.9 142.555 505.9 138.527 502.2 138.527C498.6 138.527 498.6 142.555 494.9 142.555C491.3 142.555 491.3 138.527 487.6 138.527C484 138.527 484 142.555 480.3 142.555C476.6 142.555 476.7 138.527 473 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 135.61C505.9 135.61 505.9 131.582 502.2 131.582C498.6 131.582 498.6 135.61 494.9 135.61C491.3 135.61 491.3 131.582 487.6 131.582C484 131.582 484 135.61 480.3 135.61C476.6 135.61 476.7 131.582 473 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 83.3508V39.2497H572.2L578 49.4191L585 39.2497H606.7L615.8 27.9727L632.1 83.3508H557.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 83.3508V39.2497H572.2L578 49.4191L585 39.2497H606.7L615.8 27.9727L632.1 83.3508H557.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.1 70.8655C615.358 70.8655 618 68.2058 618 64.925C618 61.6441 615.358 58.9844 612.1 58.9844C608.841 58.9844 606.2 61.6441 606.2 64.925C606.2 68.2058 608.841 70.8655 612.1 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.9 70.3634C598.3 70.3634 598.3 66.3359 594.6 66.3359C591 66.3359 591 70.3634 587.3 70.3634C583.7 70.3634 583.7 66.3359 580 66.3359C576.4 66.3359 576.4 70.3634 572.7 70.3634C569.1 70.3634 569.1 66.3359 565.4 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.9 63.4142C598.3 63.4142 598.3 59.3867 594.6 59.3867C591 59.3867 591 63.4142 587.3 63.4142C583.7 63.4142 583.7 59.3867 580 59.3867C576.4 59.3867 576.4 63.4142 572.7 63.4142C569.1 63.4142 569.1 59.3867 565.4 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.7 167.023V211.125H524.7L519 201.056L511.9 211.125H490.3L481.1 222.502L464.8 167.023H539.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.7 167.023V211.125H524.7L519 201.056L511.9 211.125H490.3L481.1 222.502L464.8 167.023H539.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.8 191.49C488.058 191.49 490.7 188.831 490.7 185.55C490.7 182.269 488.058 179.609 484.8 179.609C481.541 179.609 478.9 182.269 478.9 185.55C478.9 188.831 481.541 191.49 484.8 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 180.113C498.6 180.113 498.6 184.141 502.3 184.141C505.9 184.141 505.9 180.113 509.6 180.113C513.2 180.113 513.2 184.141 516.9 184.141C520.5 184.141 520.5 180.113 524.2 180.113C527.8 180.113 527.8 184.141 531.5 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 187.059C498.6 187.059 498.6 191.086 502.3 191.086C505.9 191.086 505.9 187.059 509.6 187.059C513.2 187.059 513.2 191.086 516.9 191.086C520.5 191.086 520.5 187.059 524.2 187.059C527.8 187.059 527.8 191.086 531.5 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 228.141V272.242H603L597.3 262.173L590.2 272.242H568.6L559.4 283.619L543.2 228.141H618Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 228.141V272.242H603L597.3 262.173L590.2 272.242H568.6L559.4 283.619L543.2 228.141H618Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.2 252.608C566.459 252.608 569.1 249.948 569.1 246.667C569.1 243.386 566.459 240.727 563.2 240.727C559.942 240.727 557.3 243.386 557.3 246.667C557.3 249.948 559.942 252.608 563.2 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.3 241.23C576.9 241.23 576.9 245.258 580.6 245.258C584.2 245.258 584.2 241.23 587.9 241.23C591.5 241.23 591.5 245.258 595.2 245.258C598.8 245.258 598.8 241.23 602.5 241.23C606.2 241.23 606.1 245.258 609.8 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.3 248.176C576.9 248.176 576.9 252.203 580.6 252.203C584.2 252.203 584.2 248.176 587.9 248.176C591.5 248.176 591.5 252.203 595.2 252.203C598.8 252.203 598.8 248.176 602.5 248.176C606.2 248.176 606.1 252.203 609.8 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8 283.619V239.518H479.8L485.5 249.587L492.6 239.518H514.2L523.4 228.141L539.7 283.619H464.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8 283.619V239.518H479.8L485.5 249.587L492.6 239.518H514.2L523.4 228.141L539.7 283.619H464.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 211.327V167.226H572.2L578 177.396L585 167.226H606.7L615.8 155.949L632.1 211.327H557.2Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.2 211.327V167.226H572.2L578 177.396L585 167.226H606.7L615.8 155.949L632.1 211.327H557.2Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.1 198.842C615.358 198.842 618 196.182 618 192.901C618 189.621 615.358 186.961 612.1 186.961C608.841 186.961 606.2 189.621 606.2 192.901C606.2 196.182 608.841 198.842 612.1 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.9 198.336C598.3 198.336 598.3 194.309 594.6 194.309C591 194.309 591 198.336 587.3 198.336C583.7 198.336 583.7 194.309 580 194.309C576.4 194.309 576.4 198.336 572.7 198.336C569.1 198.336 569.1 194.309 565.4 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.9 191.391C598.3 191.391 598.3 187.363 594.6 187.363C591 187.363 591 191.391 587.3 191.391C583.7 191.391 583.7 187.363 580 187.363C576.4 187.363 576.4 191.391 572.7 191.391C569.1 191.391 569.1 187.363 565.4 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 83.3508V39.2497H399L404.7 49.4191L411.7 39.2497H433.4L442.5 27.9727L458.8 83.3508H384Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 83.3508V39.2497H399L404.7 49.4191L411.7 39.2497H433.4L442.5 27.9727L458.8 83.3508H384Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7 -27.8086V16.2926H429.7L424 6.22382L417 16.2926H395.3L386.2 27.6703L369.9 -27.8086H444.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7 -27.8086V16.2926H429.7L424 6.22382L417 16.2926H395.3L386.2 27.6703L369.9 -27.8086H444.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 27.6703V-16.4309H306.5L312.3 -6.36213L319.3 -16.4309H341L350.1 -27.8086L366.4 27.6703H291.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 27.6703V-16.4309H306.5L312.3 -6.36213L319.3 -16.4309H341L350.1 -27.8086L366.4 27.6703H291.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.4 15.0843C349.658 15.0843 352.3 12.4246 352.3 9.14369C352.3 5.86281 349.658 3.20312 346.4 3.20312C343.142 3.20312 340.5 5.86281 340.5 9.14369C340.5 12.4246 343.142 15.0843 346.4 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 14.5822C332.6 14.5822 332.6 10.5547 328.9 10.5547C325.3 10.5547 325.3 14.5822 321.6 14.5822C318 14.5822 318 10.5547 314.3 10.5547C310.7 10.5547 310.7 14.5822 307 14.5822C303.3 14.5822 303.4 10.5547 299.7 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 7.63688C332.6 7.63688 332.6 3.60938 328.9 3.60938C325.3 3.60938 325.3 7.63688 321.6 7.63688C318 7.63688 318 3.60938 314.3 3.60938C310.7 3.60938 310.7 7.63688 307 7.63688C303.3 7.63688 303.4 3.60938 299.7 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 211.327V167.226H399L404.7 177.396L411.7 167.226H433.4L442.5 155.949L458.8 211.327H384Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 211.327V167.226H399L404.7 177.396L411.7 167.226H433.4L442.5 155.949L458.8 211.327H384Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.4 39.0508V83.1519H351.4L345.7 73.0832L338.6 83.1519H317L307.8 94.5296L291.5 39.0508H366.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.4 39.0508V83.1519H351.4L345.7 73.0832L338.6 83.1519H317L307.8 94.5296L291.5 39.0508H366.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.6 63.5178C314.858 63.5178 317.5 60.8582 317.5 57.5773C317.5 54.2964 314.858 51.6367 311.6 51.6367C308.341 51.6367 305.7 54.2964 305.7 57.5773C305.7 60.8582 308.341 63.5178 311.6 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7 52.1406C325.3 52.1406 325.3 56.1681 329 56.1681C332.6 56.1681 332.6 52.1406 336.3 52.1406C339.9 52.1406 339.9 56.1681 343.6 56.1681C347.2 56.1681 347.2 52.1406 350.9 52.1406C354.6 52.1406 354.5 56.1681 358.2 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7 59.0859C325.3 59.0859 325.3 63.1134 329 63.1134C332.6 63.1134 332.6 59.0859 336.3 59.0859C339.9 59.0859 339.9 63.1134 343.6 63.1134C347.2 63.1134 347.2 59.0859 350.9 59.0859C354.6 59.0859 354.5 63.1134 358.2 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7 100.168V144.269H429.7L424 134.2L417 144.269H395.3L386.2 155.647L369.9 100.168H444.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7 100.168V144.269H429.7L424 134.2L417 144.269H395.3L386.2 155.647L369.9 100.168H444.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9 124.635C393.158 124.635 395.8 121.975 395.8 118.694C395.8 115.414 393.158 112.754 389.9 112.754C386.642 112.754 384 115.414 384 118.694C384 121.975 386.642 124.635 389.9 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.1 113.258C403.7 113.258 403.7 117.285 407.4 117.285C411 117.285 411 113.258 414.7 113.258C418.3 113.258 418.3 117.285 422 117.285C425.6 117.285 425.6 113.258 429.3 113.258C432.9 113.258 432.9 117.285 436.6 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.1 120.203C403.7 120.203 403.7 124.231 407.4 124.231C411 124.231 411 120.203 414.7 120.203C418.3 120.203 418.3 124.231 422 124.231C425.6 124.231 425.6 120.203 429.3 120.203C432.9 120.203 432.9 124.231 436.6 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 155.647V111.546H306.5L312.3 121.614L319.3 111.546H341L350.1 100.168L366.4 155.647H291.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 155.647V111.546H306.5L312.3 121.614L319.3 111.546H341L350.1 100.168L366.4 155.647H291.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.4 143.061C349.658 143.061 352.3 140.401 352.3 137.12C352.3 133.839 349.658 131.18 346.4 131.18C343.142 131.18 340.5 133.839 340.5 137.12C340.5 140.401 343.142 143.061 346.4 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 142.555C332.6 142.555 332.6 138.527 328.9 138.527C325.3 138.527 325.3 142.555 321.6 142.555C318 142.555 318 138.527 314.3 138.527C310.7 138.527 310.7 142.555 307 142.555C303.3 142.555 303.4 138.527 299.7 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 135.61C332.6 135.61 332.6 131.582 328.9 131.582C325.3 131.582 325.3 135.61 321.6 135.61C318 135.61 318 131.582 314.3 131.582C310.7 131.582 310.7 135.61 307 135.61C303.3 135.61 303.4 131.582 299.7 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 83.3508V39.2497H399L404.7 49.4191L411.7 39.2497H433.4L442.5 27.9727L458.8 83.3508H384Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 83.3508V39.2497H399L404.7 49.4191L411.7 39.2497H433.4L442.5 27.9727L458.8 83.3508H384Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.8 70.8655C442.058 70.8655 444.7 68.2058 444.7 64.925C444.7 61.6441 442.058 58.9844 438.8 58.9844C435.541 58.9844 432.9 61.6441 432.9 64.925C432.9 68.2058 435.541 70.8655 438.8 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6 70.3634C425 70.3634 425 66.3359 421.3 66.3359C417.7 66.3359 417.7 70.3634 414 70.3634C410.4 70.3634 410.4 66.3359 406.7 66.3359C403.1 66.3359 403.1 70.3634 399.4 70.3634C395.7 70.3634 395.8 66.3359 392.1 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6 63.4142C425 63.4142 425 59.3867 421.3 59.3867C417.7 59.3867 417.7 63.4142 414 63.4142C410.4 63.4142 410.4 59.3867 406.7 59.3867C403.1 59.3867 403.1 63.4142 399.4 63.4142C395.7 63.4142 395.8 59.3867 392.1 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.4 167.023V211.125H351.4L345.7 201.056L338.6 211.125H317L307.8 222.502L291.5 167.023H366.4Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.4 167.023V211.125H351.4L345.7 201.056L338.6 211.125H317L307.8 222.502L291.5 167.023H366.4Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.6 191.49C314.858 191.49 317.5 188.831 317.5 185.55C317.5 182.269 314.858 179.609 311.6 179.609C308.341 179.609 305.7 182.269 305.7 185.55C305.7 188.831 308.341 191.49 311.6 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7 180.113C325.3 180.113 325.3 184.141 329 184.141C332.6 184.141 332.6 180.113 336.3 180.113C339.9 180.113 339.9 184.141 343.6 184.141C347.2 184.141 347.2 180.113 350.9 180.113C354.6 180.113 354.5 184.141 358.2 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7 187.059C325.3 187.059 325.3 191.086 329 191.086C332.6 191.086 332.6 187.059 336.3 187.059C339.9 187.059 339.9 191.086 343.6 191.086C347.2 191.086 347.2 187.059 350.9 187.059C354.6 187.059 354.5 191.086 358.2 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7 228.141V272.242H429.7L424 262.173L417 272.242H395.3L386.2 283.619L369.9 228.141H444.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7 228.141V272.242H429.7L424 262.173L417 272.242H395.3L386.2 283.619L369.9 228.141H444.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9 252.608C393.158 252.608 395.8 249.948 395.8 246.667C395.8 243.386 393.158 240.727 389.9 240.727C386.642 240.727 384 243.386 384 246.667C384 249.948 386.642 252.608 389.9 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.1 241.23C403.7 241.23 403.7 245.258 407.4 245.258C411 245.258 411 241.23 414.7 241.23C418.3 241.23 418.3 245.258 422 245.258C425.6 245.258 425.6 241.23 429.3 241.23C432.9 241.23 432.9 245.258 436.6 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.1 248.176C403.7 248.176 403.7 252.203 407.4 252.203C411 252.203 411 248.176 414.7 248.176C418.3 248.176 418.3 252.203 422 252.203C425.6 252.203 425.6 248.176 429.3 248.176C432.9 248.176 432.9 252.203 436.6 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 283.619V239.518H306.5L312.3 249.587L319.3 239.518H341L350.1 228.141L366.4 283.619H291.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 283.619V239.518H306.5L312.3 249.587L319.3 239.518H341L350.1 228.141L366.4 283.619H291.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 211.327V167.226H399L404.7 177.396L411.7 167.226H433.4L442.5 155.949L458.8 211.327H384Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 211.327V167.226H399L404.7 177.396L411.7 167.226H433.4L442.5 155.949L458.8 211.327H384Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.8 198.842C442.058 198.842 444.7 196.182 444.7 192.901C444.7 189.621 442.058 186.961 438.8 186.961C435.541 186.961 432.9 189.621 432.9 192.901C432.9 196.182 435.541 198.842 438.8 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6 198.336C425 198.336 425 194.309 421.3 194.309C417.7 194.309 417.7 198.336 414 198.336C410.4 198.336 410.4 194.309 406.7 194.309C403.1 194.309 403.1 198.336 399.4 198.336C395.7 198.336 395.8 194.309 392.1 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6 191.391C425 191.391 425 187.363 421.3 187.363C417.7 187.363 417.7 191.391 414 191.391C410.4 191.391 410.4 187.363 406.7 187.363C403.1 187.363 403.1 191.391 399.4 191.391C395.7 191.391 395.8 187.363 392.1 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 83.3508V39.2497H225.7L231.4 49.4191L238.5 39.2497H260.1L269.3 27.9727L285.5 83.3508H210.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 83.3508V39.2497H225.7L231.4 49.4191L238.5 39.2497H260.1L269.3 27.9727L285.5 83.3508H210.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 -27.8086V16.2926H256.5L250.7 6.22382L243.7 16.2926H222.1L212.9 27.6703L196.6 -27.8086H271.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 -27.8086V16.2926H256.5L250.7 6.22382L243.7 16.2926H222.1L212.9 27.6703L196.6 -27.8086H271.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 27.6703V-16.4309H133.3L139 -6.36213L146 -16.4309H167.7L176.8 -27.8086L193.1 27.6703H118.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 27.6703V-16.4309H133.3L139 -6.36213L146 -16.4309H167.7L176.8 -27.8086L193.1 27.6703H118.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.1 15.0843C176.359 15.0843 179 12.4246 179 9.14369C179 5.86281 176.359 3.20312 173.1 3.20312C169.842 3.20312 167.2 5.86281 167.2 9.14369C167.2 12.4246 169.842 15.0843 173.1 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9 14.5822C159.3 14.5822 159.3 10.5547 155.6 10.5547C152 10.5547 152 14.5822 148.3 14.5822C144.7 14.5822 144.7 10.5547 141 10.5547C137.4 10.5547 137.4 14.5822 133.7 14.5822C130 14.5822 130.1 10.5547 126.4 10.5547",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9 7.63688C159.3 7.63688 159.3 3.60938 155.6 3.60938C152 3.60938 152 7.63688 148.3 7.63688C144.7 7.63688 144.7 3.60938 141 3.60938C137.4 3.60938 137.4 7.63688 133.7 7.63688C130 7.63688 130.1 3.60938 126.4 3.60938",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 211.327V167.226H225.7L231.4 177.396L238.5 167.226H260.1L269.3 155.949L285.5 211.327H210.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 211.327V167.226H225.7L231.4 177.396L238.5 167.226H260.1L269.3 155.949L285.5 211.327H210.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1 39.0508V83.1519H178.1L172.4 73.0832L165.4 83.1519H143.7L134.5 94.5296L118.3 39.0508H193.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1 39.0508V83.1519H178.1L172.4 73.0832L165.4 83.1519H143.7L134.5 94.5296L118.3 39.0508H193.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3 63.5178C141.558 63.5178 144.2 60.8582 144.2 57.5773C144.2 54.2964 141.558 51.6367 138.3 51.6367C135.041 51.6367 132.4 54.2964 132.4 57.5773C132.4 60.8582 135.041 63.5178 138.3 63.5178Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5 52.1406C152.1 52.1406 152.1 56.1681 155.8 56.1681C159.4 56.1681 159.4 52.1406 163.1 52.1406C166.7 52.1406 166.7 56.1681 170.4 56.1681C174 56.1681 174 52.1406 177.7 52.1406C181.4 52.1406 181.3 56.1681 185 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5 59.0859C152.1 59.0859 152.1 63.1134 155.8 63.1134C159.4 63.1134 159.4 59.0859 163.1 59.0859C166.7 59.0859 166.7 63.1134 170.4 63.1134C174 63.1134 174 59.0859 177.7 59.0859C181.4 59.0859 181.3 63.1134 185 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 100.168V144.269H256.5L250.7 134.2L243.7 144.269H222.1L212.9 155.647L196.6 100.168H271.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 100.168V144.269H256.5L250.7 134.2L243.7 144.269H222.1L212.9 155.647L196.6 100.168H271.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6 124.635C219.859 124.635 222.5 121.975 222.5 118.694C222.5 115.414 219.859 112.754 216.6 112.754C213.342 112.754 210.7 115.414 210.7 118.694C210.7 121.975 213.342 124.635 216.6 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 113.258C230.4 113.258 230.4 117.285 234.1 117.285C237.7 117.285 237.7 113.258 241.4 113.258C245 113.258 245 117.285 248.7 117.285C252.3 117.285 252.3 113.258 256 113.258C259.6 113.258 259.6 117.285 263.3 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 120.203C230.4 120.203 230.4 124.231 234.1 124.231C237.7 124.231 237.7 120.203 241.4 120.203C245 120.203 245 124.231 248.7 124.231C252.3 124.231 252.3 120.203 256 120.203C259.6 120.203 259.6 124.231 263.3 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 155.647V111.546H133.3L139 121.614L146 111.546H167.7L176.8 100.168L193.1 155.647H118.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 155.647V111.546H133.3L139 121.614L146 111.546H167.7L176.8 100.168L193.1 155.647H118.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.1 143.061C176.359 143.061 179 140.401 179 137.12C179 133.839 176.359 131.18 173.1 131.18C169.842 131.18 167.2 133.839 167.2 137.12C167.2 140.401 169.842 143.061 173.1 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9 142.555C159.3 142.555 159.3 138.527 155.6 138.527C152 138.527 152 142.555 148.3 142.555C144.7 142.555 144.7 138.527 141 138.527C137.4 138.527 137.4 142.555 133.7 142.555C130 142.555 130.1 138.527 126.4 138.527",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9 135.61C159.3 135.61 159.3 131.582 155.6 131.582C152 131.582 152 135.61 148.3 135.61C144.7 135.61 144.7 131.582 141 131.582C137.4 131.582 137.4 135.61 133.7 135.61C130 135.61 130.1 131.582 126.4 131.582",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 83.3508V39.2497H225.7L231.4 49.4191L238.5 39.2497H260.1L269.3 27.9727L285.5 83.3508H210.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 83.3508V39.2497H225.7L231.4 49.4191L238.5 39.2497H260.1L269.3 27.9727L285.5 83.3508H210.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 70.8655C268.759 70.8655 271.4 68.2058 271.4 64.925C271.4 61.6441 268.759 58.9844 265.5 58.9844C262.242 58.9844 259.6 61.6441 259.6 64.925C259.6 68.2058 262.242 70.8655 265.5 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 70.3634C251.8 70.3634 251.8 66.3359 248.1 66.3359C244.5 66.3359 244.5 70.3634 240.8 70.3634C237.2 70.3634 237.2 66.3359 233.5 66.3359C229.9 66.3359 229.9 70.3634 226.2 70.3634C222.6 70.3634 222.6 66.3359 218.9 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 63.4142C251.8 63.4142 251.8 59.3867 248.1 59.3867C244.5 59.3867 244.5 63.4142 240.8 63.4142C237.2 63.4142 237.2 59.3867 233.5 59.3867C229.9 59.3867 229.9 63.4142 226.2 63.4142C222.6 63.4142 222.6 59.3867 218.9 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1 167.023V211.125H178.1L172.4 201.056L165.4 211.125H143.7L134.5 222.502L118.3 167.023H193.1Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1 167.023V211.125H178.1L172.4 201.056L165.4 211.125H143.7L134.5 222.502L118.3 167.023H193.1Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3 191.49C141.558 191.49 144.2 188.831 144.2 185.55C144.2 182.269 141.558 179.609 138.3 179.609C135.041 179.609 132.4 182.269 132.4 185.55C132.4 188.831 135.041 191.49 138.3 191.49Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5 180.113C152.1 180.113 152.1 184.141 155.8 184.141C159.4 184.141 159.4 180.113 163.1 180.113C166.7 180.113 166.7 184.141 170.4 184.141C174 184.141 174 180.113 177.7 180.113C181.4 180.113 181.3 184.141 185 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5 187.059C152.1 187.059 152.1 191.086 155.8 191.086C159.4 191.086 159.4 187.059 163.1 187.059C166.7 187.059 166.7 191.086 170.4 191.086C174 191.086 174 187.059 177.7 187.059C181.4 187.059 181.3 191.086 185 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 228.141V272.242H256.5L250.7 262.173L243.7 272.242H222.1L212.9 283.619L196.6 228.141H271.5Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 228.141V272.242H256.5L250.7 262.173L243.7 272.242H222.1L212.9 283.619L196.6 228.141H271.5Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6 252.608C219.859 252.608 222.5 249.948 222.5 246.667C222.5 243.386 219.859 240.727 216.6 240.727C213.342 240.727 210.7 243.386 210.7 246.667C210.7 249.948 213.342 252.608 216.6 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 241.23C230.4 241.23 230.4 245.258 234.1 245.258C237.7 245.258 237.7 241.23 241.4 241.23C245 241.23 245 245.258 248.7 245.258C252.3 245.258 252.3 241.23 256 241.23C259.6 241.23 259.6 245.258 263.3 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8 248.176C230.4 248.176 230.4 252.203 234.1 252.203C237.7 252.203 237.7 248.176 241.4 248.176C245 248.176 245 252.203 248.7 252.203C252.3 252.203 252.3 248.176 256 248.176C259.6 248.176 259.6 252.203 263.3 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 283.619V239.518H133.3L139 249.587L146 239.518H167.7L176.8 228.141L193.1 283.619H118.3Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 283.619V239.518H133.3L139 249.587L146 239.518H167.7L176.8 228.141L193.1 283.619H118.3Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 211.327V167.226H225.7L231.4 177.396L238.5 167.226H260.1L269.3 155.949L285.5 211.327H210.7Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 211.327V167.226H225.7L231.4 177.396L238.5 167.226H260.1L269.3 155.949L285.5 211.327H210.7Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 198.842C268.759 198.842 271.4 196.182 271.4 192.901C271.4 189.621 268.759 186.961 265.5 186.961C262.242 186.961 259.6 189.621 259.6 192.901C259.6 196.182 262.242 198.842 265.5 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 198.336C251.8 198.336 251.8 194.309 248.1 194.309C244.5 194.309 244.5 198.336 240.8 198.336C237.2 198.336 237.2 194.309 233.5 194.309C229.9 194.309 229.9 198.336 226.2 198.336C222.6 198.336 222.6 194.309 218.9 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 191.391C251.8 191.391 251.8 187.363 248.1 187.363C244.5 187.363 244.5 191.391 240.8 191.391C237.2 191.391 237.2 187.363 233.5 187.363C229.9 187.363 229.9 191.391 226.2 191.391C222.6 191.391 222.6 187.363 218.9 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 83.3508V39.2497H52.3999L58.0999 49.4191L65.1999 39.2497H86.7999L95.9999 27.9727L112.3 83.3508H37.3999Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 83.3508V39.2497H52.3999L58.0999 49.4191L65.1999 39.2497H86.7999L95.9999 27.9727L112.3 83.3508H37.3999Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1998 -27.8086V16.2926H83.1998L77.4998 6.22382L70.3998 16.2926H48.7998L39.5998 27.6703L23.2998 -27.8086H98.1998Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1998 -27.8086V16.2926H83.1998L77.4998 6.22382L70.3998 16.2926H48.7998L39.5998 27.6703L23.2998 -27.8086H98.1998Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 27.6703V-16.4309H-40L-34.3 -6.36213L-27.2 -16.4309H-5.6L3.6 -27.8086L19.8 27.6703H-55Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 27.6703V-16.4309H-40L-34.3 -6.36213L-27.2 -16.4309H-5.6L3.6 -27.8086L19.8 27.6703H-55Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.2001 15.0843C3.05838 15.0843 5.6999 12.4246 5.6999 9.14369C5.6999 5.86281 3.05838 3.20312 -0.2001 3.20312C-3.45858 3.20312 -6.1001 5.86281 -6.1001 9.14369C-6.1001 12.4246 -3.45858 15.0843 -0.2001 15.0843Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 211.327V167.226H52.3999L58.0999 177.396L65.1999 167.226H86.7999L95.9999 155.949L112.3 211.327H37.3999Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 211.327V167.226H52.3999L58.0999 177.396L65.1999 167.226H86.7999L95.9999 155.949L112.3 211.327H37.3999Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 39.0508V83.1519H4.9L-0.900002 73.0832L-7.9 83.1519H-29.6L-38.7 94.5296L-55 39.0508H19.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 39.0508V83.1519H4.9L-0.900002 73.0832L-7.9 83.1519H-29.6L-38.7 94.5296L-55 39.0508H19.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.7998 52.1406C-21.1998 52.1406 -21.1998 56.1681 -17.4998 56.1681C-13.8998 56.1681 -13.8998 52.1406 -10.1998 52.1406C-6.59981 52.1406 -6.59981 56.1681 -2.89981 56.1681C0.700193 56.1681 0.700196 52.1406 4.4002 52.1406C8.1002 52.1406 8.00019 56.1681 11.7002 56.1681",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.7998 59.0859C-21.1998 59.0859 -21.1998 63.1134 -17.4998 63.1134C-13.8998 63.1134 -13.8998 59.0859 -10.1998 59.0859C-6.59981 59.0859 -6.59981 63.1134 -2.89981 63.1134C0.700193 63.1134 0.700196 59.0859 4.4002 59.0859C8.1002 59.0859 8.00019 63.1134 11.7002 63.1134",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1998 100.168V144.269H83.1998L77.4998 134.2L70.3998 144.269H48.7998L39.5998 155.647L23.2998 100.168H98.1998Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1998 100.168V144.269H83.1998L77.4998 134.2L70.3998 144.269H48.7998L39.5998 155.647L23.2998 100.168H98.1998Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2999 124.635C46.5584 124.635 49.1999 121.975 49.1999 118.694C49.1999 115.414 46.5584 112.754 43.2999 112.754C40.0414 112.754 37.3999 115.414 37.3999 118.694C37.3999 121.975 40.0414 124.635 43.2999 124.635Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 113.258C57.1 113.258 57.1 117.285 60.8 117.285C64.4 117.285 64.4 113.258 68.1 113.258C71.7 113.258 71.7 117.285 75.4 117.285C79 117.285 79 113.258 82.7 113.258C86.3 113.258 86.3 117.285 90 117.285",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 120.203C57.1 120.203 57.1 124.231 60.8 124.231C64.4 124.231 64.4 120.203 68.1 120.203C71.7 120.203 71.7 124.231 75.4 124.231C79 124.231 79 120.203 82.7 120.203C86.3 120.203 86.3 124.231 90 124.231",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 155.647V111.546H-40L-34.3 121.614L-27.2 111.546H-5.6L3.6 100.168L19.8 155.647H-55Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 155.647V111.546H-40L-34.3 121.614L-27.2 111.546H-5.6L3.6 100.168L19.8 155.647H-55Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.2001 143.061C3.05838 143.061 5.6999 140.401 5.6999 137.12C5.6999 133.839 3.05838 131.18 -0.2001 131.18C-3.45858 131.18 -6.1001 133.839 -6.1001 137.12C-6.1001 140.401 -3.45858 143.061 -0.2001 143.061Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 83.3508V39.2497H52.3999L58.0999 49.4191L65.1999 39.2497H86.7999L95.9999 27.9727L112.3 83.3508H37.3999Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 83.3508V39.2497H52.3999L58.0999 49.4191L65.1999 39.2497H86.7999L95.9999 27.9727L112.3 83.3508H37.3999Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2999 70.8655C95.5584 70.8655 98.1999 68.2058 98.1999 64.925C98.1999 61.6441 95.5584 58.9844 92.2999 58.9844C89.0414 58.9844 86.3999 61.6441 86.3999 64.925C86.3999 68.2058 89.0414 70.8655 92.2999 70.8655Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1001 70.3634C78.5001 70.3634 78.5001 66.3359 74.8001 66.3359C71.2001 66.3359 71.2001 70.3634 67.5001 70.3634C63.9001 70.3634 63.9001 66.3359 60.2001 66.3359C56.6001 66.3359 56.6001 70.3634 52.9001 70.3634C49.3001 70.3634 49.3001 66.3359 45.6001 66.3359",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1001 63.4142C78.5001 63.4142 78.5001 59.3867 74.8001 59.3867C71.2001 59.3867 71.2001 63.4142 67.5001 63.4142C63.9001 63.4142 63.9001 59.3867 60.2001 59.3867C56.6001 59.3867 56.6001 63.4142 52.9001 63.4142C49.3001 63.4142 49.3001 59.3867 45.6001 59.3867",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 167.023V211.125H4.9L-0.900002 201.056L-7.9 211.125H-29.6L-38.7 222.502L-55 167.023H19.8Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 167.023V211.125H4.9L-0.900002 201.056L-7.9 211.125H-29.6L-38.7 222.502L-55 167.023H19.8Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.7998 180.113C-21.1998 180.113 -21.1998 184.141 -17.4998 184.141C-13.8998 184.141 -13.8998 180.113 -10.1998 180.113C-6.59981 180.113 -6.59981 184.141 -2.89981 184.141C0.700193 184.141 0.700196 180.113 4.4002 180.113C8.1002 180.113 8.00019 184.141 11.7002 184.141",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.7998 187.059C-21.1998 187.059 -21.1998 191.086 -17.4998 191.086C-13.8998 191.086 -13.8998 187.059 -10.1998 187.059C-6.59981 187.059 -6.59981 191.086 -2.89981 191.086C0.700193 191.086 0.700196 187.059 4.4002 187.059C8.1002 187.059 8.00019 191.086 11.7002 191.086",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1998 228.141V272.242H83.1998L77.4998 262.173L70.3998 272.242H48.7998L39.5998 283.619L23.2998 228.141H98.1998Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1998 228.141V272.242H83.1998L77.4998 262.173L70.3998 272.242H48.7998L39.5998 283.619L23.2998 228.141H98.1998Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2999 252.608C46.5584 252.608 49.1999 249.948 49.1999 246.667C49.1999 243.386 46.5584 240.727 43.2999 240.727C40.0414 240.727 37.3999 243.386 37.3999 246.667C37.3999 249.948 40.0414 252.608 43.2999 252.608Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 241.23C57.1 241.23 57.1 245.258 60.8 245.258C64.4 245.258 64.4 241.23 68.1 241.23C71.7 241.23 71.7 245.258 75.4 245.258C79 245.258 79 241.23 82.7 241.23C86.3 241.23 86.3 245.258 90 245.258",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 248.176C57.1 248.176 57.1 252.203 60.8 252.203C64.4 252.203 64.4 248.176 68.1 248.176C71.7 248.176 71.7 252.203 75.4 252.203C79 252.203 79 248.176 82.7 248.176C86.3 248.176 86.3 252.203 90 252.203",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 283.619V239.518H-40L-34.3 249.587L-27.2 239.518H-5.6L3.6 228.141L19.8 283.619H-55Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 283.619V239.518H-40L-34.3 249.587L-27.2 239.518H-5.6L3.6 228.141L19.8 283.619H-55Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 211.327V167.226H52.3999L58.0999 177.396L65.1999 167.226H86.7999L95.9999 155.949L112.3 211.327H37.3999Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 211.327V167.226H52.3999L58.0999 177.396L65.1999 167.226H86.7999L95.9999 155.949L112.3 211.327H37.3999Z",
    stroke: "#E6570E",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2999 198.842C95.5584 198.842 98.1999 196.182 98.1999 192.901C98.1999 189.621 95.5584 186.961 92.2999 186.961C89.0414 186.961 86.3999 189.621 86.3999 192.901C86.3999 196.182 89.0414 198.842 92.2999 198.842Z",
    fill: "#FFE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1001 198.336C78.5001 198.336 78.5001 194.309 74.8001 194.309C71.2001 194.309 71.2001 198.336 67.5001 198.336C63.9001 198.336 63.9001 194.309 60.2001 194.309C56.6001 194.309 56.6001 198.336 52.9001 198.336C49.3001 198.336 49.3001 194.309 45.6001 194.309",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1001 191.391C78.5001 191.391 78.5001 187.363 74.8001 187.363C71.2001 187.363 71.2001 191.391 67.5001 191.391C63.9001 191.391 63.9001 187.363 60.2001 187.363C56.6001 187.363 56.6001 191.391 52.9001 191.391C49.3001 191.391 49.3001 187.363 45.6001 187.363",
    stroke: "white",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImg);
export default __webpack_public_path__ + "static/media/background-img.fda1581929a294b374ac160685cfb876.svg";
export { ForwardRef as ReactComponent };